import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationMethylationDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const pemt = getGenePalette(geneColors.PEMT);
  const cbs = getGenePalette(geneColors.CBS);
  const cth = getGenePalette(geneColors.CTH);
  const suox = getGenePalette(geneColors.SUOX);
  const tph = getGenePalette(geneColors.TPH);
  const mtrr = getGenePalette(geneColors.MTRR);
  const ahcy = getGenePalette(geneColors.AHCY);
  const bhmt = getGenePalette(geneColors.BHMT);
  const dhfr = getGenePalette(geneColors.DHFR);
  const th = getGenePalette(geneColors.TH);
  const comt = getGenePalette(geneColors.COMT);
  const nos3 = getGenePalette(geneColors.NOS3);
  const sod1_3 = getGenePalette(geneColors["SOD1/3"]);
  const gpx1 = getGenePalette(geneColors.GPX1);
  const tcn2 = getGenePalette(geneColors.TCN2);
  const fut2 = getGenePalette(geneColors.FUT2);
  const shmt = getGenePalette(geneColors.SHMT);
  const mthfd1 = getGenePalette(geneColors.MTHFD1);
  const mthfr = getGenePalette(geneColors.MTHFR);
  const mtr = getGenePalette(geneColors.MTR);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211496)">
        <rect width={1424} height={869} transform="translate(0 212)" fill="white" />
        <g id="methylation-methylation-diagram">
          <rect width={1462} height={869} transform="translate(0 212)" fill="white" />
          <path
            id="Vector 292"
            d="M1184.65 572.106L1185.26 572.456L1185.96 571.243L1185.35 570.894L1185 571.5L1184.65 572.106ZM1199 499L1191.08 497.387L1193.64 505.053L1199 499ZM1185 571.5L1185.35 570.894C1167.36 560.524 1157.83 547.382 1158.41 534.9C1159 522.454 1169.69 510.199 1193.26 501.658L1193.02 501L1192.78 500.342C1169.03 508.947 1157.64 521.525 1157.02 534.834C1156.39 548.107 1166.5 561.642 1184.65 572.106L1185 571.5Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8"
            d="M992 636L999.878 637.81L997.507 630.083L992 636ZM1037 579H1036.3C1036.3 603.973 1020.28 625.276 997.784 633.494L998.024 634.152L998.264 634.809C1021.29 626.4 1037.7 604.591 1037.7 579H1037ZM992 522L991.83 522.679C1017.4 529.079 1036.3 551.875 1036.3 579H1037H1037.7C1037.7 551.203 1018.33 527.87 992.17 521.321L992 522Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8_2"
            d="M961 523L953.053 521.526L955.75 529.146L961 523ZM959.966 635L960.175 634.332C936.714 626.957 919.7 605.042 919.7 579.157H919H918.3C918.3 605.671 935.728 628.114 959.756 635.668L959.966 635ZM919 579.157H919.7C919.7 555.092 934.406 534.458 955.328 525.749L955.059 525.103L954.79 524.457C933.365 533.375 918.3 554.507 918.3 579.157H919Z"
            fill="#282828"
          />
          <g id="lines_2">
            <path
              id="Vector_4"
              d="M1155.34 669.3L1155.34 670L1156.74 670L1156.74 669.3L1156.04 669.3L1155.34 669.3ZM1156.04 467L1152 474L1160.08 474L1156.04 467ZM1156.04 669.3L1156.74 669.3L1156.74 473.3L1156.04 473.3L1155.34 473.3L1155.34 669.3L1156.04 669.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_5"
              d="M1207.34 601.3L1207.34 602L1208.74 602L1208.74 601.3L1208.04 601.3L1207.34 601.3ZM1208.04 583L1204 590L1212.08 590L1208.04 583ZM1208.04 601.3L1208.74 601.3L1208.74 589.3L1208.04 589.3L1207.34 589.3L1207.34 601.3L1208.04 601.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect width={23} height={20} transform="translate(1238 609)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1238.07} y={623.098}>
                SAH
              </tspan>
            </text>
          </g>
          <path
            id="Vector 429"
            d="M985.121 418.038L985.673 418.468V418.468L985.121 418.038ZM936.653 456.528L935.965 456.658L936.653 456.528ZM955.232 492L952.511 484.389L947.28 490.551L955.232 492ZM985.121 372L984.455 372.216C993.698 400.748 987.382 414.001 984.569 417.607L985.121 418.038L985.673 418.468C988.855 414.388 995.125 400.61 985.787 371.784L985.121 372ZM985.121 418.038L984.569 417.607C974.448 430.587 961.166 432.556 950.838 435.086C945.729 436.337 941.209 437.756 938.381 440.911C935.504 444.12 934.509 448.951 935.965 456.658L936.653 456.528L937.34 456.398C935.919 448.875 936.97 444.581 939.423 441.845C941.924 439.055 946.019 437.707 951.171 436.446C961.366 433.949 975.196 431.904 985.673 418.468L985.121 418.038ZM936.653 456.528L935.965 456.658C939.368 474.674 945.294 483.648 949.928 488.412L950.43 487.924L950.932 487.436C946.522 482.902 940.702 474.194 937.34 456.398L936.653 456.528Z"
            fill="#1A1A1A"
          />
          <path
            id="Ellipse 9"
            d="M1208 456L1203.75 449.125L1199.92 456.244L1208 456ZM1182 445L1181.81 445.673C1188.88 447.711 1195.68 450.39 1202.14 453.641L1202.45 453.016L1202.77 452.391C1196.24 449.101 1189.36 446.39 1182.19 444.327L1182 445Z"
            fill="#1A1A1A"
          />
          <path
            id="Ellipse 10"
            d="M1254.28 608C1262.42 592.462 1267 574.908 1267 556.326C1267 525.577 1254.45 497.644 1234 477"
            stroke="#1A1A1A"
            strokeWidth={1.4}
          />
          <path
            id="Ellipse 11"
            d="M1242 627L1234.43 629.824L1240.66 634.971L1242 627ZM1189 665L1196.98 666.284L1194.1 658.731L1189 665ZM1237.99 631.857L1237.46 631.397C1225.88 644.66 1211.24 655.253 1194.62 662.11L1194.89 662.757L1195.15 663.404C1211.98 656.464 1226.8 645.743 1238.52 632.318L1237.99 631.857Z"
            fill="#1A1A1A"
          />
          <path
            id="Ellipse 7"
            d="M1189 665.329L1181.09 663.647L1183.59 671.335L1189 665.329ZM1102.58 450L1094.52 449.401L1098.03 456.681L1102.58 450ZM1183.01 667.274L1182.81 666.603C1172.44 669.659 1161.47 671.3 1150.11 671.3V672V672.7C1161.6 672.7 1172.71 671.04 1183.21 667.946L1183.01 667.274ZM1034 555.93H1034.7C1034.7 511.269 1060.08 472.535 1097.22 453.36L1096.9 452.738L1096.58 452.116C1059 471.522 1033.3 510.725 1033.3 555.93H1034ZM1150.11 672V671.3C1086.37 671.3 1034.7 619.647 1034.7 555.93H1034H1033.3C1033.3 620.42 1085.6 672.7 1150.11 672.7V672Z"
            fill="#1A1A1A"
          />
          <g id="Report titles_2">
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={1189.41} y={574.4}>
                Betaine
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={1187.19} y={614.4}>
                Choline
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={24} height={20} transform="translate(1201 488)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={1201.46} y={501.4}>
                DMG
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={78} height={20} transform="translate(1107 432)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1115.04} y={446.098}>
                Methionine
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={34} height={20} transform="translate(968 343)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={976.012} y={357.098}>
                B12
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={95} height={20} transform="translate(1107 655)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1115.34} y={669.098}>
                Homocysteine
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={48} height={20} transform="translate(1204 459)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1212.18} y={473.098}>
                SAMe
              </tspan>
            </text>
          </g>
          <g id="report-recycle-symbol">
            <g id="Vector_6">
              <mask id="path-45-inside-2_18291_211496" fill="white">
                <path d="M969.644 587.141C969.644 587.95 968.988 588.606 968.18 588.606H959.396C956.016 588.604 953.905 584.944 955.595 582.016L961.87 571.17L959.299 571.856C958.207 572.148 957.209 571.148 957.502 570.057C957.639 569.55 958.035 569.155 958.541 569.019L964.538 567.414C965.32 567.204 966.123 567.668 966.332 568.45L967.94 574.448C968.154 575.234 967.686 576.043 966.899 576.25C966.775 576.282 966.647 576.299 966.518 576.299C965.856 576.299 965.277 575.853 965.106 575.214L964.41 572.623L958.135 583.48C957.573 584.454 958.272 585.672 959.396 585.677H968.18C968.988 585.677 969.644 586.333 969.644 587.141ZM995.398 582.016L991.163 574.694C990.558 573.742 989.151 573.802 988.63 574.802C988.408 575.227 988.408 575.733 988.63 576.158L992.865 583.48C993.427 584.454 992.728 585.672 991.604 585.677H979.034L980.926 583.784C981.723 582.987 981.359 581.626 980.271 581.334C979.765 581.198 979.226 581.342 978.856 581.712L974.464 586.105C973.892 586.677 973.892 587.605 974.464 588.177L978.856 592.571C979.654 593.367 981.014 593.002 981.306 591.913C981.441 591.407 981.296 590.868 980.926 590.498L979.034 588.606H991.604C994.984 588.604 997.095 584.944 995.405 582.016H995.398ZM975.5 554.924C976.024 554.919 976.509 555.2 976.766 555.656L983.041 566.502L980.465 565.81C979.368 565.553 978.403 566.58 978.729 567.659C978.871 568.129 979.239 568.497 979.709 568.638L985.708 570.247C985.831 570.28 985.959 570.297 986.087 570.297C986.749 570.296 987.328 569.851 987.499 569.211L989.108 563.209C989.427 562.128 988.456 561.107 987.36 561.372C986.826 561.501 986.41 561.917 986.281 562.451L985.585 565.045L979.301 554.192C977.609 551.269 973.391 551.269 971.699 554.192L967.461 561.514C966.923 562.505 967.659 563.706 968.786 563.677C969.281 563.664 969.736 563.401 969.995 562.978L974.234 555.656C974.491 555.2 974.976 554.919 975.5 554.924Z" />
              </mask>
              <path
                d="M969.644 587.141C969.644 587.95 968.988 588.606 968.18 588.606H959.396C956.016 588.604 953.905 584.944 955.595 582.016L961.87 571.17L959.299 571.856C958.207 572.148 957.209 571.148 957.502 570.057C957.639 569.55 958.035 569.155 958.541 569.019L964.538 567.414C965.32 567.204 966.123 567.668 966.332 568.45L967.94 574.448C968.154 575.234 967.686 576.043 966.899 576.25C966.775 576.282 966.647 576.299 966.518 576.299C965.856 576.299 965.277 575.853 965.106 575.214L964.41 572.623L958.135 583.48C957.573 584.454 958.272 585.672 959.396 585.677H968.18C968.988 585.677 969.644 586.333 969.644 587.141ZM995.398 582.016L991.163 574.694C990.558 573.742 989.151 573.802 988.63 574.802C988.408 575.227 988.408 575.733 988.63 576.158L992.865 583.48C993.427 584.454 992.728 585.672 991.604 585.677H979.034L980.926 583.784C981.723 582.987 981.359 581.626 980.271 581.334C979.765 581.198 979.226 581.342 978.856 581.712L974.464 586.105C973.892 586.677 973.892 587.605 974.464 588.177L978.856 592.571C979.654 593.367 981.014 593.002 981.306 591.913C981.441 591.407 981.296 590.868 980.926 590.498L979.034 588.606H991.604C994.984 588.604 997.095 584.944 995.405 582.016H995.398ZM975.5 554.924C976.024 554.919 976.509 555.2 976.766 555.656L983.041 566.502L980.465 565.81C979.368 565.553 978.403 566.58 978.729 567.659C978.871 568.129 979.239 568.497 979.709 568.638L985.708 570.247C985.831 570.28 985.959 570.297 986.087 570.297C986.749 570.296 987.328 569.851 987.499 569.211L989.108 563.209C989.427 562.128 988.456 561.107 987.36 561.372C986.826 561.501 986.41 561.917 986.281 562.451L985.585 565.045L979.301 554.192C977.609 551.269 973.391 551.269 971.699 554.192L967.461 561.514C966.923 562.505 967.659 563.706 968.786 563.677C969.281 563.664 969.736 563.401 969.995 562.978L974.234 555.656C974.491 555.2 974.976 554.919 975.5 554.924Z"
                stroke="#282828"
                strokeWidth={2}
                mask="url(#path-45-inside-2_18291_211496)"
              />
            </g>
          </g>
          <path
            id="Vector 293"
            d="M1293.66 577.114L1294.28 577.45L1294.95 576.222L1294.34 575.886L1294 576.5L1293.66 577.114ZM1297 507.5L1289.37 504.834L1290.88 512.776L1297 507.5ZM1294 576.5L1294.34 575.886C1277.15 566.469 1267.34 551.966 1266.29 538.813C1265.77 532.247 1267.43 526.011 1271.45 520.862C1275.47 515.71 1281.89 511.595 1290.98 509.354L1290.81 508.674L1290.64 507.995C1281.32 510.294 1274.6 514.552 1270.35 520.001C1266.09 525.452 1264.35 532.043 1264.9 538.924C1265.99 552.665 1276.18 567.534 1293.66 577.114L1294 576.5Z"
            fill="#282828"
          />
          <path
            id="Vector 426"
            d="M1308.38 619.085L1302.47 613.574L1300.66 621.45L1308.38 619.085ZM1264.75 579.727L1264.06 579.676C1263.43 588.105 1268.98 596.508 1276.53 603.371C1284.1 610.258 1293.86 615.747 1302.03 618.336L1302.24 617.669L1302.45 617.001C1294.48 614.476 1284.9 609.091 1277.47 602.335C1270.01 595.554 1264.88 587.544 1265.45 579.779L1264.75 579.727Z"
            fill="#1A1A1A"
          />
          <g id="Report titles_9">
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={8}
              letterSpacing="0px"
            >
              <tspan x={1298.5} y={578.72}>
                Phosphatidylethanolamine{" "}
              </tspan>
              <tspan x={1298.5} y={594.72}>
                (PE)
              </tspan>
            </text>
          </g>
          <g id="gene-PEMT" {...geneGroupProps("PEMT", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M1279 529.7H1351C1352.82 529.7 1354.3 531.177 1354.3 533V549C1354.3 550.823 1352.82 552.3 1351 552.3H1279C1277.18 552.3 1275.7 550.823 1275.7 549V533C1275.7 531.177 1277.18 529.7 1279 529.7Z"
                fill={pemt.lozengeFill}
              />
              <text
                id="gene-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1297.75} y={545.767}>
                  PEMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="pemt"
              groupId="gene-snps"
              genePalette={pemt}
              startX={1283}
              startY={554}
              snpCount={getGeneSnpCount("PEMT", expectedSnps, geneColors)}
            />
          </g>
          <path
            id="Vector 426_2"
            d="M1384.54 674.401L1385.13 674.018L1384.54 674.401ZM1359.43 712.397L1357.83 704.473L1365.49 707.053L1359.43 712.397ZM1369 628.358L1369.27 629.002C1362.37 631.946 1357.22 634.498 1353.52 636.752C1349.8 639.015 1347.6 640.939 1346.52 642.602C1345.99 643.422 1345.75 644.158 1345.71 644.827C1345.67 645.492 1345.83 646.141 1346.18 646.797C1346.92 648.141 1348.46 649.473 1350.66 650.871C1352.85 652.257 1355.59 653.65 1358.63 655.153C1361.65 656.651 1364.96 658.254 1368.22 660.048C1374.74 663.628 1381.21 668.021 1385.13 674.018L1384.54 674.401L1383.96 674.784C1380.23 669.089 1374.02 664.832 1367.55 661.275C1364.31 659.499 1361.04 657.913 1358.01 656.408C1354.98 654.908 1352.17 653.485 1349.91 652.053C1347.67 650.632 1345.87 649.141 1344.96 647.469C1344.49 646.616 1344.25 645.708 1344.31 644.744C1344.36 643.784 1344.71 642.818 1345.35 641.84C1346.6 639.907 1349.02 637.85 1352.79 635.556C1356.58 633.252 1361.79 630.671 1368.72 627.714L1369 628.358ZM1384.54 674.401L1385.13 674.018C1385.92 675.23 1386.27 676.449 1386.22 677.683C1386.17 678.906 1385.73 680.085 1385.04 681.231C1383.67 683.497 1381.22 685.783 1378.46 688.217C1372.86 693.146 1365.78 698.839 1362.07 706.725L1361.44 706.427L1360.81 706.129C1364.67 697.919 1372.03 692.016 1377.53 687.166C1380.32 684.709 1382.6 682.559 1383.84 680.507C1384.45 679.494 1384.78 678.543 1384.82 677.625C1384.86 676.716 1384.61 675.781 1383.96 674.784L1384.54 674.401Z"
            fill="#1A1A1A"
          />
          <g id="Report titles_10">
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={8}
              letterSpacing="0px"
            >
              <tspan x={1300.64} y={510.72}>
                Phosphatidylcholine (PC)
              </tspan>
            </text>
          </g>
          <g id="Report titles_11">
            <rect width={94} height={20} transform="translate(1313 609)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_11"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={1313.07} y={622.4}>
                Methyl Group (-CH3)
              </tspan>
            </text>
          </g>
          <g id="Report titles_12">
            <rect width={83} height={68} transform="translate(1328 713.858)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_12"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={1328} y={727.258}>
                For methylation of{" "}
              </tspan>
              <tspan x={1328} y={743.258}>
                DNA, RNA,{" "}
              </tspan>
              <tspan x={1328} y={759.258}>
                proteins, lipids{" "}
              </tspan>
              <tspan x={1328} y={775.258}>
                and metabolites
              </tspan>
            </text>
          </g>
          <g id="Report titles_13">
            <rect width={40} height={20} transform="translate(957 464)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_13"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={957} y={477.4}>
                Oxidised
              </tspan>
            </text>
          </g>
          <g id="Report titles_14">
            <rect width={44} height={20} transform="translate(915 295)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={915} y={308.4}>
                Transport
              </tspan>
            </text>
          </g>
          <g id="Report titles_15">
            <rect width={50} height={20} transform="translate(1009 295)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_15"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={1009} y={308.4}>
                Absorption
              </tspan>
            </text>
          </g>
          <path
            id="Vector 427"
            d="M896 316.444H895.3V317.144H896V316.444ZM978 316.444H978.7V315.744H978V316.444ZM978 347L982.041 340H973.959L978 347ZM896 292H895.3V316.444H896H896.7V292H896ZM896 316.444V317.144H978V316.444V315.744H896V316.444ZM978 316.444H977.3V340.7H978H978.7V316.444H978Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 428"
            d="M1078 316.444H1078.7V317.144H1078V316.444ZM990 316.444H989.3V315.744H990V316.444ZM990 347L985.959 340H994.041L990 347ZM1078 292H1078.7V316.444H1078H1077.3V292H1078ZM1078 316.444V317.144H990V316.444V315.744H1078V316.444ZM990 316.444H990.7V340.7H990H989.3V316.444H990Z"
            fill="#1A1A1A"
          />
          <path
            id="Vector 433"
            d="M461 797.5L468 801.541V793.459L461 797.5ZM508.751 797.5H509.451V796.8H508.751V797.5ZM508.751 846.5H508.051V847.2H508.751V846.5ZM467.3 797.5V798.2H508.751V797.5V796.8H467.3V797.5ZM508.751 797.5H508.051V846.5H508.751H509.451V797.5H508.751ZM508.751 846.5V847.2H591V846.5V845.8H508.751V846.5Z"
            fill="#282828"
          />
          <path
            id="Vector 434"
            d="M484 961L491 965.041V956.958L484 961ZM508.771 961V961.7H509.471V961H508.771ZM508.771 853V852.3H508.071V853H508.771ZM490.3 961V961.7H508.771V961V960.3H490.3V961ZM508.771 961H509.471V853H508.771H508.071V961H508.771ZM508.771 853V853.7H588.771V853V852.3H508.771V853Z"
            fill="#282828"
          />
          <path
            id="Ellipse 10_2"
            d="M759 391L765.168 385.776L757.56 383.046L759 391ZM761.127 385.07L761.775 385.336C770.671 363.602 789.496 348.7 811.195 348.7V348V347.3C788.807 347.3 769.541 362.667 760.479 384.805L761.127 385.07ZM811.195 348V348.7C817.097 348.7 821.649 349.869 825.163 351.801C828.673 353.731 831.186 356.445 832.982 359.597C836.59 365.928 837.3 374.02 837.3 381H838H838.7C838.7 373.98 837.998 365.572 834.198 358.903C832.29 355.555 829.601 352.644 825.837 350.574C822.077 348.506 817.283 347.3 811.195 347.3V348Z"
            fill="#282828"
          />
          <path
            id="Vector 431"
            d="M100 550H591.384L614 506"
            stroke="#818181"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <path
            id="Vector 435"
            d="M619 932V932.7H619.7V932H619ZM545 932V931.3H544.3V932H545ZM545 1008H544.3V1008.7H545V1008ZM619 1008H619.7V1007.3H619V1008ZM619 1035L623.041 1028H614.959L619 1035ZM619 837H618.3V932H619H619.7V837H619ZM619 932V931.3H545V932V932.7H619V932ZM545 932H544.3V953H545H545.7V932H545ZM545 953H544.3V1008H545H545.7V953H545ZM545 1008V1008.7H619V1008V1007.3H545V1008ZM619 1008H618.3V1028.7H619H619.7V1008H619Z"
            fill="#282828"
          />
          <path
            id="Vector 436"
            d="M631 932V932.7H630.3V932H631ZM705 932V931.3H705.7V932H705ZM705 1008H705.7V1008.7H705V1008ZM631 1008H630.3V1007.3H631V1008ZM631 1035L626.959 1028H635.041L631 1035ZM631 837H631.7V932H631H630.3V837H631ZM631 932V931.3H705V932V932.7H631V932ZM705 932H705.7V953H705H704.3V932H705ZM705 953H705.7V1008H705H704.3V953H705ZM705 1008V1008.7H631V1008V1007.3H705V1008ZM631 1008H631.7V1028.7H631H630.3V1008H631Z"
            fill="#282828"
          />
          <path
            id="Ellipse 9_2"
            d="M654 502L661.847 503.937L659.601 496.172L654 502ZM725 411H724.3C724.3 452.329 697.27 487.378 659.84 499.582L660.057 500.248L660.274 500.913C698.26 488.528 725.7 452.956 725.7 411H725ZM654 320L653.828 320.679C694.34 330.939 724.3 367.49 724.3 411H725H725.7C725.7 366.829 695.286 329.734 654.172 319.321L654 320Z"
            fill="#282828"
          />
          <path
            id="Vector 432"
            d="M68 752L75.6217 754.691L74.1416 746.745L68 752ZM99 729L98.3587 728.719C95.7286 734.733 87.4865 746.333 74 750.173L74.1917 750.847L74.3834 751.52C88.4079 747.527 96.9101 735.525 99.6413 729.281L99 729Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8_3"
            d="M604 321L596.081 319.383L598.64 327.05L604 321ZM602.35 501L602.561 500.333C564.968 488.427 537.7 453.048 537.7 411.253H537H536.3C536.3 453.67 563.975 489.581 602.138 501.667L602.35 501ZM537 411.253H537.7C537.7 371.067 562.91 336.812 598.268 323.651L598.024 322.995L597.779 322.339C561.886 335.699 536.3 370.468 536.3 411.253H537Z"
            fill="#282828"
          />
          <path id="Vector 430" d="M566 272H629V302" stroke="#E44C4B" strokeWidth={1.4} />
          <path
            id="Vector 292_2"
            d="M673.981 646.405L673.283 646.357L673.187 647.754L673.885 647.802L673.933 647.103L673.981 646.405ZM683.002 708L690.766 705.754L684.939 700.153L683.002 708ZM673.933 647.103L673.885 647.802C677.268 648.034 680.93 648.126 684.614 648.228C688.305 648.33 692.022 648.444 695.542 648.719C699.064 648.995 702.365 649.431 705.227 650.172C708.093 650.914 710.469 651.95 712.179 653.393C713.869 654.82 714.93 656.66 715.165 659.092C715.402 661.551 714.798 664.667 713.036 668.62C709.509 676.534 701.442 687.573 686.865 702.971L687.373 703.452L687.882 703.933C702.48 688.513 710.686 677.331 714.315 669.19C716.132 665.116 716.827 661.746 716.558 658.958C716.287 656.142 715.036 653.973 713.082 652.324C711.148 650.691 708.547 649.586 705.578 648.817C702.603 648.047 699.21 647.602 695.651 647.324C692.091 647.045 688.341 646.931 684.653 646.829C680.958 646.726 677.329 646.635 673.981 646.405L673.933 647.103Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5"
            d="M757 517.71L765.083 517.74L761.067 510.725L757 517.71ZM920 608.808H919.3C919.3 621.803 916.958 634.251 912.674 645.756L913.33 646L913.986 646.244C918.328 634.585 920.7 621.972 920.7 608.808H920ZM812.927 502V502.7C871.677 502.7 919.3 550.208 919.3 608.808H920H920.7C920.7 549.431 872.447 501.3 812.927 501.3V502ZM762.469 514.579L762.799 515.197C777.734 507.222 794.8 502.7 812.927 502.7V502V501.3C794.564 501.3 777.273 505.881 762.14 513.962L762.469 514.579Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5_2"
            d="M891 682L883.206 684.141L888.957 689.82L891 682ZM886.572 686.484L886.089 685.977C867.06 704.149 841.327 715.3 813 715.3V716V716.7C841.702 716.7 867.778 705.4 887.056 686.99L886.572 686.484ZM813 716V715.3C782.427 715.3 754.874 702.31 735.512 681.523L735 682L734.488 682.477C754.103 703.536 782.021 716.7 813 716.7V716Z"
            fill="#282828"
          />
          <path
            id="Ellipse 5_3"
            d="M728 673L725.825 665.215L720.171 670.991L728 673ZM723.498 668.593L724.065 668.182C719.347 661.681 714.998 649.819 711.825 637.999C708.655 626.19 706.7 614.58 706.7 608.643H706H705.3C705.3 614.766 707.294 626.518 710.473 638.362C713.65 650.196 718.05 662.279 722.931 669.004L723.498 668.593ZM706 608.643H706.7C706.7 585.813 714.058 564.677 726.567 547.411L726 547L725.433 546.589C712.758 564.086 705.3 585.507 705.3 608.643H706Z"
            fill="#282828"
          />
          <g id="lines_4">
            <path
              id="Vector_7"
              d="M142 269.042L149 273.083V265L142 269.042ZM232.3 269.742H233V268.342H232.3V269.042V269.742ZM148.3 269.042V269.742H232.3V269.042V268.342H148.3V269.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_5">
            <text
              id="Line Label"
              transform="translate(363 476)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={78.4473} y={16.086}>
                Decrease BH4
              </tspan>
            </text>
            <path
              id="Vector_8"
              d="M363.7 503.7L597.3 503.7"
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_6">
            <path
              id="Vector_9"
              d="M330 273.042L337 277.083V269L330 273.042ZM496.3 273.742H497V272.342H496.3V273.042V273.742ZM336.3 273.042V273.742L496.3 273.742V273.042V272.342L336.3 272.342V273.042Z"
              fill="#E44C4B"
            />
          </g>
          <text
            id="Toxic"
            fill="#E44C4B"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Regular"
            fontSize={14}
            letterSpacing="0em"
          >
            <tspan x={457.477} y={291.76}>
              Toxic
            </tspan>
          </text>
          <g id="lines_7">
            <text
              id="Line Label_2"
              transform="translate(72 384) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={22.7852} y={16.086}>
                Removes
              </tspan>
            </text>
            <path
              id="Vector_10"
              d="M102.341 383.3L102.341 384L103.741 384L103.741 383.3L103.041 383.3L102.341 383.3ZM103.041 289L98.9996 296L107.082 296L103.041 289ZM103.041 383.3L103.741 383.3L103.741 295.3L103.041 295.3L102.341 295.3L102.341 383.3L103.041 383.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_11"
              d="M99.741 551.7C99.741 551.314 99.4276 551 99.041 551C98.6544 551 98.341 551.314 98.341 551.7L99.041 551.7L99.741 551.7ZM99.041 609L103.082 602L94.9996 602L99.041 609ZM98.341 553.747C98.341 554.133 98.6544 554.447 99.041 554.447C99.4276 554.447 99.741 554.133 99.741 553.747L99.041 553.747L98.341 553.747ZM99.741 557.839C99.741 557.453 99.4276 557.139 99.041 557.139C98.6544 557.139 98.341 557.453 98.341 557.839L99.041 557.839L99.741 557.839ZM98.341 561.932C98.341 562.319 98.6544 562.632 99.041 562.632C99.4276 562.632 99.741 562.319 99.741 561.932L99.041 561.932L98.341 561.932ZM99.741 566.025C99.741 565.639 99.4276 565.325 99.041 565.325C98.6544 565.325 98.341 565.639 98.341 566.025L99.041 566.025L99.741 566.025ZM98.341 570.118C98.341 570.505 98.6544 570.818 99.041 570.818C99.4276 570.818 99.741 570.505 99.741 570.118L99.041 570.118L98.341 570.118ZM99.741 574.211C99.741 573.824 99.4276 573.511 99.041 573.511C98.6544 573.511 98.341 573.824 98.341 574.211L99.041 574.211L99.741 574.211ZM98.341 578.304C98.341 578.69 98.6544 579.004 99.041 579.004C99.4276 579.004 99.741 578.69 99.741 578.304L99.041 578.304L98.341 578.304ZM99.741 582.397C99.741 582.01 99.4276 581.697 99.041 581.697C98.6544 581.697 98.341 582.01 98.341 582.397L99.041 582.397L99.741 582.397ZM98.341 586.489C98.341 586.876 98.6544 587.189 99.041 587.189C99.4276 587.189 99.741 586.876 99.741 586.489L99.041 586.489L98.341 586.489ZM99.741 590.582C99.741 590.196 99.4276 589.882 99.041 589.882C98.6544 589.882 98.341 590.196 98.341 590.582L99.041 590.582L99.741 590.582ZM98.341 594.675C98.341 595.062 98.6544 595.375 99.041 595.375C99.4276 595.375 99.741 595.062 99.741 594.675L99.041 594.675L98.341 594.675ZM99.741 598.768C99.741 598.381 99.4276 598.068 99.041 598.068C98.6544 598.068 98.341 598.381 98.341 598.768L99.041 598.768L99.741 598.768ZM98.341 602.861C98.341 603.248 98.6544 603.561 99.041 603.561C99.4276 603.561 99.741 603.248 99.741 602.861L99.041 602.861L98.341 602.861ZM99.741 606.954C99.741 606.567 99.4276 606.254 99.041 606.254C98.6544 606.254 98.341 606.567 98.341 606.954L99.041 606.954L99.741 606.954ZM99.041 551.7L98.341 551.7L98.341 553.747L99.041 553.747L99.741 553.747L99.741 551.7L99.041 551.7ZM99.041 557.839L98.341 557.839L98.341 561.932L99.041 561.932L99.741 561.932L99.741 557.839L99.041 557.839ZM99.041 566.025L98.341 566.025L98.341 570.118L99.041 570.118L99.741 570.118L99.741 566.025L99.041 566.025ZM99.041 574.211L98.341 574.211L98.341 578.304L99.041 578.304L99.741 578.304L99.741 574.211L99.041 574.211ZM99.041 582.397L98.341 582.397L98.341 586.489L99.041 586.489L99.741 586.489L99.741 582.397L99.041 582.397ZM99.041 590.582L98.341 590.582L98.341 594.675L99.041 594.675L99.741 594.675L99.741 590.582L99.041 590.582ZM99.041 598.768L98.341 598.768L98.341 602.861L99.041 602.861L99.741 602.861L99.741 598.768L99.041 598.768Z"
              fill="#818181"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_12"
              d="M210.741 551.7C210.741 551.314 210.428 551 210.041 551C209.654 551 209.341 551.314 209.341 551.7L210.041 551.7L210.741 551.7ZM210.041 609L214.082 602L206 602L210.041 609ZM209.341 553.747C209.341 554.133 209.654 554.447 210.041 554.447C210.428 554.447 210.741 554.133 210.741 553.747L210.041 553.747L209.341 553.747ZM210.741 557.839C210.741 557.453 210.428 557.139 210.041 557.139C209.654 557.139 209.341 557.453 209.341 557.839L210.041 557.839L210.741 557.839ZM209.341 561.932C209.341 562.319 209.654 562.632 210.041 562.632C210.428 562.632 210.741 562.319 210.741 561.932L210.041 561.932L209.341 561.932ZM210.741 566.025C210.741 565.639 210.428 565.325 210.041 565.325C209.654 565.325 209.341 565.639 209.341 566.025L210.041 566.025L210.741 566.025ZM209.341 570.118C209.341 570.505 209.654 570.818 210.041 570.818C210.428 570.818 210.741 570.505 210.741 570.118L210.041 570.118L209.341 570.118ZM210.741 574.211C210.741 573.824 210.428 573.511 210.041 573.511C209.654 573.511 209.341 573.824 209.341 574.211L210.041 574.211L210.741 574.211ZM209.341 578.304C209.341 578.69 209.654 579.004 210.041 579.004C210.428 579.004 210.741 578.69 210.741 578.304L210.041 578.304L209.341 578.304ZM210.741 582.397C210.741 582.01 210.428 581.697 210.041 581.697C209.654 581.697 209.341 582.01 209.341 582.397L210.041 582.397L210.741 582.397ZM209.341 586.489C209.341 586.876 209.654 587.189 210.041 587.189C210.428 587.189 210.741 586.876 210.741 586.489L210.041 586.489L209.341 586.489ZM210.741 590.582C210.741 590.196 210.428 589.882 210.041 589.882C209.654 589.882 209.341 590.196 209.341 590.582L210.041 590.582L210.741 590.582ZM209.341 594.675C209.341 595.062 209.654 595.375 210.041 595.375C210.428 595.375 210.741 595.062 210.741 594.675L210.041 594.675L209.341 594.675ZM210.741 598.768C210.741 598.381 210.428 598.068 210.041 598.068C209.654 598.068 209.341 598.381 209.341 598.768L210.041 598.768L210.741 598.768ZM209.341 602.861C209.341 603.248 209.654 603.561 210.041 603.561C210.428 603.561 210.741 603.248 210.741 602.861L210.041 602.861L209.341 602.861ZM210.741 606.954C210.741 606.567 210.428 606.254 210.041 606.254C209.654 606.254 209.341 606.567 209.341 606.954L210.041 606.954L210.741 606.954ZM210.041 551.7L209.341 551.7L209.341 553.747L210.041 553.747L210.741 553.747L210.741 551.7L210.041 551.7ZM210.041 557.839L209.341 557.839L209.341 561.932L210.041 561.932L210.741 561.932L210.741 557.839L210.041 557.839ZM210.041 566.025L209.341 566.025L209.341 570.118L210.041 570.118L210.741 570.118L210.741 566.025L210.041 566.025ZM210.041 574.211L209.341 574.211L209.341 578.304L210.041 578.304L210.741 578.304L210.741 574.211L210.041 574.211ZM210.041 582.397L209.341 582.397L209.341 586.489L210.041 586.489L210.741 586.489L210.741 582.397L210.041 582.397ZM210.041 590.582L209.341 590.582L209.341 594.675L210.041 594.675L210.741 594.675L210.741 590.582L210.041 590.582ZM210.041 598.768L209.341 598.768L209.341 602.861L210.041 602.861L210.741 602.861L210.741 598.768L210.041 598.768Z"
              fill="#818181"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_13"
              d="M306.741 551.7C306.741 551.314 306.428 551 306.041 551C305.654 551 305.341 551.314 305.341 551.7L306.041 551.7L306.741 551.7ZM306.041 609L310.082 602L302 602L306.041 609ZM305.341 553.747C305.341 554.133 305.654 554.447 306.041 554.447C306.428 554.447 306.741 554.133 306.741 553.747L306.041 553.747L305.341 553.747ZM306.741 557.839C306.741 557.453 306.428 557.139 306.041 557.139C305.654 557.139 305.341 557.453 305.341 557.839L306.041 557.839L306.741 557.839ZM305.341 561.932C305.341 562.319 305.654 562.632 306.041 562.632C306.428 562.632 306.741 562.319 306.741 561.932L306.041 561.932L305.341 561.932ZM306.741 566.025C306.741 565.639 306.428 565.325 306.041 565.325C305.654 565.325 305.341 565.639 305.341 566.025L306.041 566.025L306.741 566.025ZM305.341 570.118C305.341 570.505 305.654 570.818 306.041 570.818C306.428 570.818 306.741 570.505 306.741 570.118L306.041 570.118L305.341 570.118ZM306.741 574.211C306.741 573.824 306.428 573.511 306.041 573.511C305.654 573.511 305.341 573.824 305.341 574.211L306.041 574.211L306.741 574.211ZM305.341 578.304C305.341 578.69 305.654 579.004 306.041 579.004C306.428 579.004 306.741 578.69 306.741 578.304L306.041 578.304L305.341 578.304ZM306.741 582.397C306.741 582.01 306.428 581.697 306.041 581.697C305.654 581.697 305.341 582.01 305.341 582.397L306.041 582.397L306.741 582.397ZM305.341 586.489C305.341 586.876 305.654 587.189 306.041 587.189C306.428 587.189 306.741 586.876 306.741 586.489L306.041 586.489L305.341 586.489ZM306.741 590.582C306.741 590.196 306.428 589.882 306.041 589.882C305.654 589.882 305.341 590.196 305.341 590.582L306.041 590.582L306.741 590.582ZM305.341 594.675C305.341 595.062 305.654 595.375 306.041 595.375C306.428 595.375 306.741 595.062 306.741 594.675L306.041 594.675L305.341 594.675ZM306.741 598.768C306.741 598.381 306.428 598.068 306.041 598.068C305.654 598.068 305.341 598.381 305.341 598.768L306.041 598.768L306.741 598.768ZM305.341 602.861C305.341 603.248 305.654 603.561 306.041 603.561C306.428 603.561 306.741 603.248 306.741 602.861L306.041 602.861L305.341 602.861ZM306.741 606.954C306.741 606.567 306.428 606.254 306.041 606.254C305.654 606.254 305.341 606.567 305.341 606.954L306.041 606.954L306.741 606.954ZM306.041 551.7L305.341 551.7L305.341 553.747L306.041 553.747L306.741 553.747L306.741 551.7L306.041 551.7ZM306.041 557.839L305.341 557.839L305.341 561.932L306.041 561.932L306.741 561.932L306.741 557.839L306.041 557.839ZM306.041 566.025L305.341 566.025L305.341 570.118L306.041 570.118L306.741 570.118L306.741 566.025L306.041 566.025ZM306.041 574.211L305.341 574.211L305.341 578.304L306.041 578.304L306.741 578.304L306.741 574.211L306.041 574.211ZM306.041 582.397L305.341 582.397L305.341 586.489L306.041 586.489L306.741 586.489L306.741 582.397L306.041 582.397ZM306.041 590.582L305.341 590.582L305.341 594.675L306.041 594.675L306.741 594.675L306.741 590.582L306.041 590.582ZM306.041 598.768L305.341 598.768L305.341 602.861L306.041 602.861L306.741 602.861L306.741 598.768L306.041 598.768Z"
              fill="#818181"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_14"
              d="M434.741 552.7C434.741 552.314 434.428 552 434.041 552C433.654 552 433.341 552.314 433.341 552.7L434.041 552.7L434.741 552.7ZM434.041 610L438.082 603L430 603L434.041 610ZM433.341 554.747C433.341 555.133 433.654 555.447 434.041 555.447C434.428 555.447 434.741 555.133 434.741 554.747L434.041 554.747L433.341 554.747ZM434.741 558.839C434.741 558.453 434.428 558.139 434.041 558.139C433.654 558.139 433.341 558.453 433.341 558.839L434.041 558.839L434.741 558.839ZM433.341 562.932C433.341 563.319 433.654 563.632 434.041 563.632C434.428 563.632 434.741 563.319 434.741 562.932L434.041 562.932L433.341 562.932ZM434.741 567.025C434.741 566.639 434.428 566.325 434.041 566.325C433.654 566.325 433.341 566.639 433.341 567.025L434.041 567.025L434.741 567.025ZM433.341 571.118C433.341 571.505 433.654 571.818 434.041 571.818C434.428 571.818 434.741 571.505 434.741 571.118L434.041 571.118L433.341 571.118ZM434.741 575.211C434.741 574.824 434.428 574.511 434.041 574.511C433.654 574.511 433.341 574.824 433.341 575.211L434.041 575.211L434.741 575.211ZM433.341 579.304C433.341 579.69 433.654 580.004 434.041 580.004C434.428 580.004 434.741 579.69 434.741 579.304L434.041 579.304L433.341 579.304ZM434.741 583.397C434.741 583.01 434.428 582.697 434.041 582.697C433.654 582.697 433.341 583.01 433.341 583.397L434.041 583.397L434.741 583.397ZM433.341 587.489C433.341 587.876 433.654 588.189 434.041 588.189C434.428 588.189 434.741 587.876 434.741 587.489L434.041 587.489L433.341 587.489ZM434.741 591.582C434.741 591.196 434.428 590.882 434.041 590.882C433.654 590.882 433.341 591.196 433.341 591.582L434.041 591.582L434.741 591.582ZM433.341 595.675C433.341 596.062 433.654 596.375 434.041 596.375C434.428 596.375 434.741 596.062 434.741 595.675L434.041 595.675L433.341 595.675ZM434.741 599.768C434.741 599.381 434.428 599.068 434.041 599.068C433.654 599.068 433.341 599.381 433.341 599.768L434.041 599.768L434.741 599.768ZM433.341 603.861C433.341 604.248 433.654 604.561 434.041 604.561C434.428 604.561 434.741 604.248 434.741 603.861L434.041 603.861L433.341 603.861ZM434.741 607.954C434.741 607.567 434.428 607.254 434.041 607.254C433.654 607.254 433.341 607.567 433.341 607.954L434.041 607.954L434.741 607.954ZM434.041 552.7L433.341 552.7L433.341 554.747L434.041 554.747L434.741 554.747L434.741 552.7L434.041 552.7ZM434.041 558.839L433.341 558.839L433.341 562.932L434.041 562.932L434.741 562.932L434.741 558.839L434.041 558.839ZM434.041 567.025L433.341 567.025L433.341 571.118L434.041 571.118L434.741 571.118L434.741 567.025L434.041 567.025ZM434.041 575.211L433.341 575.211L433.341 579.304L434.041 579.304L434.741 579.304L434.741 575.211L434.041 575.211ZM434.041 583.397L433.341 583.397L433.341 587.489L434.041 587.489L434.741 587.489L434.741 583.397L434.041 583.397ZM434.041 591.582L433.341 591.582L433.341 595.675L434.041 595.675L434.741 595.675L434.741 591.582L434.041 591.582ZM434.041 599.768L433.341 599.768L433.341 603.861L434.041 603.861L434.741 603.861L434.741 599.768L434.041 599.768Z"
              fill="#818181"
            />
          </g>
          <g id="Report titles_16">
            <rect width={36} height={28} transform="translate(86 251)" fill="white" />
            <g id="25-Hydroxy Vitamin D_16">
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={86.3458} y={271.129}>
                  H
                </tspan>
                <tspan x={103.162} y={271.129}>
                  O
                </tspan>
              </text>
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={97.1427} y={271.129}>
                  ₂
                </tspan>
                <tspan x={115.959} y={271.129}>
                  ₂
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_17">
            <rect width={79} height={52} transform="translate(362 247)" fill="white" />
            <g id="25-Hydroxy Vitamin D_17">
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={385.909} y={267.129}>
                  O
                </tspan>
              </text>
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={398.706} y={267.129}>
                  ₂{" "}
                </tspan>
              </text>
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={407.749} y={267.129}>
                  •⁻
                </tspan>
              </text>
            </g>
            <text
              id="Sub Label"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={362.446} y={291.76}>
                Superoxides
              </tspan>
            </text>
          </g>
          <g id="Report titles_18">
            <text
              id="25-Hydroxy Vitamin D_18"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={797.408} y={395.08}>
                Folic Acid{" "}
              </tspan>
              <tspan x={795.023} y={411.08}>
                and folate
              </tspan>
            </text>
          </g>
          <g id="Report titles_19">
            <text
              id="25-Hydroxy Vitamin D_19"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={735.016} y={407.08}>
                DHF
              </tspan>
            </text>
          </g>
          <g id="Report titles_20">
            <text
              id="25-Hydroxy Vitamin D_20"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={500.35} y={362.08}>
                STRESS
              </tspan>
            </text>
          </g>
          <g id="Report titles_21">
            <text
              id="25-Hydroxy Vitamin D_21"
              fill="#818181"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={24}
              letterSpacing="0em"
            >
              <tspan x={218.02} y={600.16}>
                +
              </tspan>
            </text>
          </g>
          <g id="Report titles_22">
            <rect width={88} height={20} transform="translate(493 232)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_22"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={493.328} y={245.4}>
                Uncoupled Enzyme
              </tspan>
            </text>
          </g>
          <g id="Report titles_23">
            <rect x={174.7} y={361.7} width={184.6} height={142.6} fill="white" />
            <rect
              x={174.7}
              y={361.7}
              width={184.6}
              height={142.6}
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <text
              id="25-Hydroxy Vitamin D_23"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={190} y={389.08}>
                BPA{" "}
              </tspan>
              <tspan x={190} y={405.08}>
                Smoking{" "}
              </tspan>
              <tspan x={190} y={421.08}>
                Aluminium{" "}
              </tspan>
              <tspan x={190} y={437.08}>
                Chemotherapy{" "}
              </tspan>
              <tspan x={190} y={453.08}>
                Perfluorinated substances{" "}
              </tspan>
              <tspan x={190} y={469.08}>
                Chronic viral infections (long{" "}
              </tspan>
              <tspan x={190} y={485.08}>
                COVID, hepatitis etc.)
              </tspan>
            </text>
          </g>
          <g id="Report titles_24">
            <rect width={38} height={20} transform="translate(608 308)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_24"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={616.096} y={322.086}>
                BH2
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_25">
              <rect width={44} height={20} transform="translate(77 612)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_25"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={77.0332} y={626.08}>
                  Arginine
                </tspan>
              </text>
            </g>
            <g id="lines_12">
              <path
                id="Vector_15"
                d="M99.659 636.7L99.659 636L98.259 636L98.259 636.7L98.959 636.7L99.659 636.7ZM98.959 784L103 777L94.9175 777L98.959 784ZM98.959 636.7L98.259 636.7L98.259 777.7L98.959 777.7L99.659 777.7L99.659 636.7L98.959 636.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_26">
              <rect width={91} height={20} transform="translate(52 784)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_26"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={52.1309} y={798.08}>
                  Nitric Oxide (NO)
                </tspan>
              </text>
            </g>
            <g id="lines_13">
              <path
                id="Vector_16"
                d="M98.159 808.7C98.159 808.314 97.8456 808 97.459 808C97.0724 808 96.759 808.314 96.759 808.7L97.459 808.7L98.159 808.7ZM97.459 927L101.5 920L93.4175 920L97.459 927ZM96.759 810.672C96.759 811.058 97.0724 811.372 97.459 811.372C97.8456 811.372 98.159 811.058 98.159 810.672L97.459 810.672L96.759 810.672ZM98.159 814.615C98.159 814.229 97.8456 813.915 97.459 813.915C97.0724 813.915 96.759 814.229 96.759 814.615L97.459 814.615L98.159 814.615ZM96.759 818.559C96.759 818.945 97.0724 819.259 97.459 819.259C97.8456 819.259 98.159 818.945 98.159 818.559L97.459 818.559L96.759 818.559ZM98.159 822.502C98.159 822.115 97.8456 821.802 97.459 821.802C97.0724 821.802 96.759 822.115 96.759 822.502L97.459 822.502L98.159 822.502ZM96.759 826.445C96.759 826.832 97.0724 827.145 97.459 827.145C97.8456 827.145 98.159 826.832 98.159 826.445L97.459 826.445L96.759 826.445ZM98.159 830.389C98.159 830.002 97.8456 829.689 97.459 829.689C97.0724 829.689 96.759 830.002 96.759 830.389L97.459 830.389L98.159 830.389ZM96.759 834.332C96.759 834.718 97.0724 835.032 97.459 835.032C97.8456 835.032 98.159 834.718 98.159 834.332L97.459 834.332L96.759 834.332ZM98.159 838.275C98.159 837.889 97.8456 837.575 97.459 837.575C97.0724 837.575 96.759 837.889 96.759 838.275L97.459 838.275L98.159 838.275ZM96.759 842.219C96.759 842.605 97.0724 842.919 97.459 842.919C97.8456 842.919 98.159 842.605 98.159 842.219L97.459 842.219L96.759 842.219ZM98.159 846.162C98.159 845.775 97.8456 845.462 97.459 845.462C97.0724 845.462 96.759 845.775 96.759 846.162L97.459 846.162L98.159 846.162ZM96.759 850.105C96.759 850.492 97.0724 850.805 97.459 850.805C97.8456 850.805 98.159 850.492 98.159 850.105L97.459 850.105L96.759 850.105ZM98.159 854.049C98.159 853.662 97.8456 853.349 97.459 853.349C97.0724 853.349 96.759 853.662 96.759 854.049L97.459 854.049L98.159 854.049ZM96.759 857.992C96.759 858.378 97.0724 858.692 97.459 858.692C97.8456 858.692 98.159 858.378 98.159 857.992L97.459 857.992L96.759 857.992ZM98.159 861.935C98.159 861.549 97.8456 861.235 97.459 861.235C97.0724 861.235 96.759 861.549 96.759 861.935L97.459 861.935L98.159 861.935ZM96.759 865.879C96.759 866.265 97.0724 866.579 97.459 866.579C97.8456 866.579 98.159 866.265 98.159 865.879L97.459 865.879L96.759 865.879ZM98.159 869.822C98.159 869.435 97.8456 869.122 97.459 869.122C97.0724 869.122 96.759 869.435 96.759 869.822L97.459 869.822L98.159 869.822ZM96.759 873.765C96.759 874.152 97.0724 874.465 97.459 874.465C97.8456 874.465 98.159 874.152 98.159 873.765L97.459 873.765L96.759 873.765ZM98.159 877.709C98.159 877.322 97.8456 877.009 97.459 877.009C97.0724 877.009 96.759 877.322 96.759 877.709L97.459 877.709L98.159 877.709ZM96.759 881.652C96.759 882.038 97.0724 882.352 97.459 882.352C97.8456 882.352 98.159 882.038 98.159 881.652L97.459 881.652L96.759 881.652ZM98.159 885.595C98.159 885.209 97.8456 884.895 97.459 884.895C97.0724 884.895 96.759 885.209 96.759 885.595L97.459 885.595L98.159 885.595ZM96.759 889.539C96.759 889.925 97.0724 890.239 97.459 890.239C97.8456 890.239 98.159 889.925 98.159 889.539L97.459 889.539L96.759 889.539ZM98.159 893.482C98.159 893.095 97.8456 892.782 97.459 892.782C97.0724 892.782 96.759 893.095 96.759 893.482L97.459 893.482L98.159 893.482ZM96.759 897.425C96.759 897.812 97.0724 898.125 97.459 898.125C97.8456 898.125 98.159 897.812 98.159 897.425L97.459 897.425L96.759 897.425ZM98.159 901.369C98.159 900.982 97.8456 900.669 97.459 900.669C97.0724 900.669 96.759 900.982 96.759 901.369L97.459 901.369L98.159 901.369ZM96.759 905.312C96.759 905.698 97.0724 906.012 97.459 906.012C97.8456 906.012 98.159 905.698 98.159 905.312L97.459 905.312L96.759 905.312ZM98.159 909.255C98.159 908.869 97.8456 908.555 97.459 908.555C97.0724 908.555 96.759 908.869 96.759 909.255L97.459 909.255L98.159 909.255ZM96.759 913.199C96.759 913.585 97.0724 913.899 97.459 913.899C97.8456 913.899 98.159 913.585 98.159 913.199L97.459 913.199L96.759 913.199ZM98.159 917.142C98.159 916.755 97.8456 916.442 97.459 916.442C97.0724 916.442 96.759 916.755 96.759 917.142L97.459 917.142L98.159 917.142ZM96.759 921.085C96.759 921.472 97.0724 921.785 97.459 921.785C97.8456 921.785 98.159 921.472 98.159 921.085L97.459 921.085L96.759 921.085ZM98.159 925.029C98.159 924.642 97.8456 924.329 97.459 924.329C97.0724 924.329 96.759 924.642 96.759 925.029L97.459 925.029L98.159 925.029ZM97.459 808.7L96.759 808.7L96.759 810.672L97.459 810.672L98.159 810.672L98.159 808.7L97.459 808.7ZM97.459 814.615L96.759 814.615L96.759 818.559L97.459 818.559L98.159 818.559L98.159 814.615L97.459 814.615ZM97.459 822.502L96.759 822.502L96.759 826.445L97.459 826.445L98.159 826.445L98.159 822.502L97.459 822.502ZM97.459 830.389L96.759 830.389L96.759 834.332L97.459 834.332L98.159 834.332L98.159 830.389L97.459 830.389ZM97.459 838.275L96.759 838.275L96.759 842.219L97.459 842.219L98.159 842.219L98.159 838.275L97.459 838.275ZM97.459 846.162L96.759 846.162L96.759 850.105L97.459 850.105L98.159 850.105L98.159 846.162L97.459 846.162ZM97.459 854.049L96.759 854.049L96.759 857.992L97.459 857.992L98.159 857.992L98.159 854.049L97.459 854.049ZM97.459 861.935L96.759 861.935L96.759 865.879L97.459 865.879L98.159 865.879L98.159 861.935L97.459 861.935ZM97.459 869.822L96.759 869.822L96.759 873.765L97.459 873.765L98.159 873.765L98.159 869.822L97.459 869.822ZM97.459 877.709L96.759 877.709L96.759 881.652L97.459 881.652L98.159 881.652L98.159 877.709L97.459 877.709ZM97.459 885.595L96.759 885.595L96.759 889.539L97.459 889.539L98.159 889.539L98.159 885.595L97.459 885.595ZM97.459 893.482L96.759 893.482L96.759 897.425L97.459 897.425L98.159 897.425L98.159 893.482L97.459 893.482ZM97.459 901.369L96.759 901.369L96.759 905.312L97.459 905.312L98.159 905.312L98.159 901.369L97.459 901.369ZM97.459 909.255L96.759 909.255L96.759 913.199L97.459 913.199L98.159 913.199L98.159 909.255L97.459 909.255ZM97.459 917.142L96.759 917.142L96.759 921.085L97.459 921.085L98.159 921.085L98.159 917.142L97.459 917.142Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="Frame 466">
            <path
              d="M172.042 935V935.7H174C174.449 935.7 174.875 935.789 175.263 935.95L175.53 935.304C176.508 935.709 177.29 936.491 177.695 937.469L177.05 937.737C177.211 938.125 177.3 938.551 177.3 939V941H178V945H177.3V949H178V953H177.3V957H178V961H177.3V965H178V969H177.3V971C177.3 971.449 177.211 971.875 177.05 972.263L177.695 972.53C177.29 973.508 176.508 974.29 175.53 974.695L175.263 974.05C174.875 974.211 174.449 974.3 174 974.3H172.042V975H168.125V974.3H164.208V975H160.292V974.3H156.375V975H152.458V974.3H148.542V975H144.625V974.3H140.708V975H136.792V974.3H132.875V975H128.958V974.3H125.042V975H121.125V974.3H117.208V975H113.292V974.3H109.375V975H105.458V974.3H101.542V975H97.625V974.3H93.708V975H89.792V974.3H85.875V975H81.958V974.3H78.042V975H74.125V974.3H70.208V975H66.292V974.3H62.375V975H58.458V974.3H54.542V975H50.625V974.3H46.708V975H42.792V974.3H38.875V975H34.958V974.3H33C32.5514 974.3 32.1254 974.211 31.7373 974.05L31.4688 974.695C30.491 974.29 29.709 973.508 29.3037 972.53L29.9502 972.263C29.8094 971.923 29.7233 971.554 29.7041 971.167L29.7002 971V969H29V965H29.7002V961H29V957H29.7002V953H29V949H29.7002V945H29V941H29.7002V939C29.7002 938.551 29.7893 938.125 29.9502 937.737L29.3037 937.469C29.7092 936.491 30.4911 935.709 31.4688 935.304L31.7373 935.95C32.1254 935.789 32.5514 935.7 33 935.7H34.958V935H38.875V935.7H42.792V935H46.708V935.7H50.625V935H54.542V935.7H58.458V935H62.375V935.7H66.292V935H70.208V935.7H74.125V935H78.042V935.7H81.958V935H85.875V935.7H89.792V935H93.708V935.7H97.625V935H101.542V935.7H105.458V935H109.375V935.7H113.292V935H117.208V935.7H121.125V935H125.042V935.7H128.958V935H132.875V935.7H136.792V935H140.708V935.7H144.625V935H148.542V935.7H152.458V935H156.375V935.7H160.292V935H164.208V935.7H168.125V935H172.042Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={37.3896} y={959.767}>
                  Healthy vasodilation
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 467">
            <path
              d="M346.958 927V927.7H349C349.449 927.7 349.875 927.789 350.263 927.95L350.53 927.304C351.508 927.709 352.29 928.491 352.695 929.469L352.05 929.737C352.211 930.125 352.3 930.551 352.3 931V933H353V937H352.3V941H353V945H352.3V949H353V953H352.3V957H353V961H352.3V965H353V969H352.3V973H353V977H352.3V981H353V985H352.3V987C352.3 987.449 352.211 987.875 352.05 988.263L352.695 988.53C352.29 989.508 351.508 990.29 350.53 990.695L350.263 990.05C349.875 990.211 349.449 990.3 349 990.3H346.958V991H342.875V990.3H338.792V991H334.708V990.3H330.625V991H326.542V990.3H322.458V991H318.375V990.3H314.292V991H310.208V990.3H306.125V991H302.042V990.3H297.958V991H293.875V990.3H289.792V991H285.708V990.3H281.625V991H277.542V990.3H273.458V991H269.375V990.3H265.292V991H261.208V990.3H257.125V991H253.042V990.3H248.958V991H244.875V990.3H240.792V991H236.708V990.3H232.625V991H228.542V990.3H224.458V991H220.375V990.3H216.292V991H212.208V990.3H208.125V991H204.042V990.3H202C201.551 990.3 201.125 990.211 200.737 990.05L200.469 990.695C199.491 990.29 198.709 989.508 198.304 988.53L198.95 988.263C198.809 987.923 198.723 987.554 198.704 987.167L198.7 987V985H198V981H198.7V977H198V973H198.7V969H198V965H198.7V961H198V957H198.7V953H198V949H198.7V945H198V941H198.7V937H198V933H198.7V931C198.7 930.551 198.789 930.125 198.95 929.737L198.304 929.469C198.709 928.491 199.491 927.709 200.469 927.304L200.737 927.95C201.125 927.789 201.551 927.7 202 927.7H204.042V927H208.125V927.7H212.208V927H216.292V927.7H220.375V927H224.458V927.7H228.542V927H232.625V927.7H236.708V927H240.792V927.7H244.875V927H248.958V927.7H253.042V927H257.125V927.7H261.208V927H265.292V927.7H269.375V927H273.458V927.7H277.542V927H281.625V927.7H285.708V927H289.792V927.7H293.875V927H297.958V927.7H302.042V927H306.125V927.7H310.208V927H314.292V927.7H318.375V927H322.458V927.7H326.542V927H330.625V927.7H334.708V927H338.792V927.7H342.875V927H346.958Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_2">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={219.192} y={951.767}>
                  Regulates muscle{" "}
                </tspan>
                <tspan x={206.197} y={975.767}>
                  movement and mood
                </tspan>
              </text>
            </g>
          </g>
          <g id="Frame 468">
            <path
              d="M476.077 927V927.7H478C478.449 927.7 478.875 927.789 479.263 927.95L479.53 927.304C480.508 927.709 481.29 928.491 481.695 929.469L481.05 929.737C481.211 930.125 481.3 930.551 481.3 931V933H482V937H481.3V941H482V945H481.3V949H482V953H481.3V957H482V961H481.3V965H482V969H481.3V973H482V977H481.3V981H482V985H481.3V987C481.3 987.449 481.211 987.875 481.05 988.263L481.695 988.53C481.29 989.508 480.508 990.29 479.53 990.695L479.263 990.05C478.875 990.211 478.449 990.3 478 990.3H476.077V991H472.23V990.3H468.385V991H464.538V990.3H460.692V991H456.846V990.3H453V991H449.154V990.3H445.308V991H441.462V990.3H437.615V991H433.77V990.3H429.923V991H426.077V990.3H422.23V991H418.385V990.3H414.538V991H410.692V990.3H406.846V991H403V990.3H399.154V991H395.308V990.3H391.462V991H387.615V990.3H383.77V991H379.923V990.3H378C377.551 990.3 377.125 990.211 376.737 990.05L376.469 990.695C375.491 990.29 374.709 989.508 374.304 988.53L374.95 988.263C374.809 987.923 374.723 987.554 374.704 987.167L374.7 987V985H374V981H374.7V977H374V973H374.7V969H374V965H374.7V961H374V957H374.7V953H374V949H374.7V945H374V941H374.7V937H374V933H374.7V931C374.7 930.551 374.789 930.125 374.95 929.737L374.304 929.469C374.709 928.491 375.491 927.709 376.469 927.304L376.737 927.95C377.125 927.789 377.551 927.7 378 927.7H379.923V927H383.77V927.7H387.615V927H391.462V927.7H395.308V927H399.154V927.7H403V927H406.846V927.7H410.692V927H414.538V927.7H418.385V927H422.23V927.7H426.077V927H429.923V927.7H433.77V927H437.615V927.7H441.462V927H445.308V927.7H449.154V927H453V927.7H456.846V927H460.692V927.7H464.538V927H468.385V927.7H472.23V927H476.077Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block_3">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={387.094} y={951.767}>
                  Adrenaline &{" "}
                </tspan>
                <tspan x={382.404} y={975.767}>
                  Noradrenaline
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_3">
            <g id="Report titles_27">
              <rect width={84} height={20} transform="translate(166 784)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_27"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={166.281} y={798.08}>
                  Fatty Aldehyde
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_28">
              <rect width={40} height={20} transform="translate(28 748)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_28"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={10}
                letterSpacing="0px"
              >
                <tspan x={28.21} y={761.4}>
                  Citrulline
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_5">
            <g id="Report titles_29">
              <rect width={118} height={52} transform="translate(654 871)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_29"
                fill="#818181"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={654} y={885.08}>
                  Adds methyl group to{" "}
                </tspan>
                <tspan x={654} y={901.08}>
                  inactivate hazardous{" "}
                </tspan>
                <tspan x={654} y={917.08}>
                  catechol estrogens
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_6">
            <g id="Report titles_30">
              <rect width={62} height={20} transform="translate(515 819)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_30"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={515.291} y={833.08}>
                  Breakdown
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_7">
            <g id="Report titles_31">
              <rect width={40} height={36} transform="translate(107 736)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_31"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={10}
                letterSpacing="0px"
              >
                <tspan x={107.171} y={749.4}>
                  Coupled{" "}
                </tspan>
                <tspan x={109.529} y={765.4}>
                  Enzyme
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_8">
            <g id="Report titles_32">
              <rect width={52} height={20} transform="translate(283 784)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_32"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={283.061} y={798.08}>
                  Serotonin
                </tspan>
              </text>
            </g>
            <g id="lines_14">
              <path
                id="Vector_17"
                d="M309.659 808.7C309.659 808.314 309.346 808 308.959 808C308.572 808 308.259 808.314 308.259 808.7L308.959 808.7L309.659 808.7ZM308.959 923L313 916L304.918 916L308.959 923ZM308.259 810.741C308.259 811.128 308.572 811.441 308.959 811.441C309.346 811.441 309.659 811.128 309.659 810.741L308.959 810.741L308.259 810.741ZM309.659 814.823C309.659 814.437 309.346 814.123 308.959 814.123C308.572 814.123 308.259 814.437 308.259 814.823L308.959 814.823L309.659 814.823ZM308.259 818.906C308.259 819.292 308.572 819.606 308.959 819.606C309.346 819.606 309.659 819.292 309.659 818.906L308.959 818.906L308.259 818.906ZM309.659 822.988C309.659 822.601 309.346 822.288 308.959 822.288C308.572 822.288 308.259 822.601 308.259 822.988L308.959 822.988L309.659 822.988ZM308.259 827.07C308.259 827.456 308.572 827.77 308.959 827.77C309.346 827.77 309.659 827.456 309.659 827.07L308.959 827.07L308.259 827.07ZM309.659 831.152C309.659 830.765 309.346 830.452 308.959 830.452C308.572 830.452 308.259 830.765 308.259 831.152L308.959 831.152L309.659 831.152ZM308.259 835.234C308.259 835.621 308.572 835.934 308.959 835.934C309.346 835.934 309.659 835.621 309.659 835.234L308.959 835.234L308.259 835.234ZM309.659 839.316C309.659 838.93 309.346 838.616 308.959 838.616C308.572 838.616 308.259 838.93 308.259 839.316L308.959 839.316L309.659 839.316ZM308.259 843.398C308.259 843.785 308.572 844.098 308.959 844.098C309.346 844.098 309.659 843.785 309.659 843.398L308.959 843.398L308.259 843.398ZM309.659 847.481C309.659 847.094 309.346 846.781 308.959 846.781C308.572 846.781 308.259 847.094 308.259 847.481L308.959 847.481L309.659 847.481ZM308.259 851.563C308.259 851.949 308.572 852.263 308.959 852.263C309.346 852.263 309.659 851.949 309.659 851.563L308.959 851.563L308.259 851.563ZM309.659 855.645C309.659 855.258 309.346 854.945 308.959 854.945C308.572 854.945 308.259 855.258 308.259 855.645L308.959 855.645L309.659 855.645ZM308.259 859.727C308.259 860.114 308.572 860.427 308.959 860.427C309.346 860.427 309.659 860.114 309.659 859.727L308.959 859.727L308.259 859.727ZM309.659 863.809C309.659 863.423 309.346 863.109 308.959 863.109C308.572 863.109 308.259 863.423 308.259 863.809L308.959 863.809L309.659 863.809ZM308.259 867.891C308.259 868.278 308.572 868.591 308.959 868.591C309.346 868.591 309.659 868.278 309.659 867.891L308.959 867.891L308.259 867.891ZM309.659 871.973C309.659 871.587 309.346 871.273 308.959 871.273C308.572 871.273 308.259 871.587 308.259 871.973L308.959 871.973L309.659 871.973ZM308.259 876.056C308.259 876.442 308.572 876.756 308.959 876.756C309.346 876.756 309.659 876.442 309.659 876.056L308.959 876.056L308.259 876.056ZM309.659 880.138C309.659 879.751 309.346 879.438 308.959 879.438C308.572 879.438 308.259 879.751 308.259 880.138L308.959 880.138L309.659 880.138ZM308.259 884.22C308.259 884.606 308.572 884.92 308.959 884.92C309.346 884.92 309.659 884.606 309.659 884.22L308.959 884.22L308.259 884.22ZM309.659 888.302C309.659 887.915 309.346 887.602 308.959 887.602C308.572 887.602 308.259 887.915 308.259 888.302L308.959 888.302L309.659 888.302ZM308.259 892.384C308.259 892.771 308.572 893.084 308.959 893.084C309.346 893.084 309.659 892.771 309.659 892.384L308.959 892.384L308.259 892.384ZM309.659 896.466C309.659 896.08 309.346 895.766 308.959 895.766C308.572 895.766 308.259 896.08 308.259 896.466L308.959 896.466L309.659 896.466ZM308.259 900.548C308.259 900.935 308.572 901.248 308.959 901.248C309.346 901.248 309.659 900.935 309.659 900.548L308.959 900.548L308.259 900.548ZM309.659 904.631C309.659 904.244 309.346 903.931 308.959 903.931C308.572 903.931 308.259 904.244 308.259 904.631L308.959 904.631L309.659 904.631ZM308.259 908.713C308.259 909.099 308.572 909.413 308.959 909.413C309.346 909.413 309.659 909.099 309.659 908.713L308.959 908.713L308.259 908.713ZM309.659 912.795C309.659 912.408 309.346 912.095 308.959 912.095C308.572 912.095 308.259 912.408 308.259 912.795L308.959 912.795L309.659 912.795ZM308.259 916.877C308.259 917.264 308.572 917.577 308.959 917.577C309.346 917.577 309.659 917.264 309.659 916.877L308.959 916.877L308.259 916.877ZM309.659 920.959C309.659 920.573 309.346 920.259 308.959 920.259C308.572 920.259 308.259 920.573 308.259 920.959L308.959 920.959L309.659 920.959ZM308.959 808.7L308.259 808.7L308.259 810.741L308.959 810.741L309.659 810.741L309.659 808.7L308.959 808.7ZM308.959 814.823L308.259 814.823L308.259 818.906L308.959 818.906L309.659 818.906L309.659 814.823L308.959 814.823ZM308.959 822.988L308.259 822.988L308.259 827.07L308.959 827.07L309.659 827.07L309.659 822.988L308.959 822.988ZM308.959 831.152L308.259 831.152L308.259 835.234L308.959 835.234L309.659 835.234L309.659 831.152L308.959 831.152ZM308.959 839.316L308.259 839.316L308.259 843.398L308.959 843.398L309.659 843.398L309.659 839.316L308.959 839.316ZM308.959 847.481L308.259 847.481L308.259 851.563L308.959 851.563L309.659 851.563L309.659 847.481L308.959 847.481ZM308.959 855.645L308.259 855.645L308.259 859.727L308.959 859.727L309.659 859.727L309.659 855.645L308.959 855.645ZM308.959 863.809L308.259 863.809L308.259 867.891L308.959 867.891L309.659 867.891L309.659 863.809L308.959 863.809ZM308.959 871.973L308.259 871.973L308.259 876.056L308.959 876.056L309.659 876.056L309.659 871.973L308.959 871.973ZM308.959 880.138L308.259 880.138L308.259 884.22L308.959 884.22L309.659 884.22L309.659 880.138L308.959 880.138ZM308.959 888.302L308.259 888.302L308.259 892.384L308.959 892.384L309.659 892.384L309.659 888.302L308.959 888.302ZM308.959 896.466L308.259 896.466L308.259 900.548L308.959 900.548L309.659 900.548L309.659 896.466L308.959 896.466ZM308.959 904.631L308.259 904.631L308.259 908.713L308.959 908.713L309.659 908.713L309.659 904.631L308.959 904.631ZM308.959 912.795L308.259 912.795L308.259 916.877L308.959 916.877L309.659 916.877L309.659 912.795L308.959 912.795Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="report-label_9">
            <g id="Report titles_33">
              <rect width={58} height={20} transform="translate(399 784)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_33"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={399.242} y={798.08}>
                  Dopamine
                </tspan>
              </text>
            </g>
            <g id="lines_15">
              <path
                id="Vector_18"
                d="M428.659 808.7C428.659 808.314 428.346 808 427.959 808C427.572 808 427.259 808.314 427.259 808.7L427.959 808.7L428.659 808.7ZM427.959 923L432 916L423.918 916L427.959 923ZM427.259 810.741C427.259 811.128 427.572 811.441 427.959 811.441C428.346 811.441 428.659 811.128 428.659 810.741L427.959 810.741L427.259 810.741ZM428.659 814.823C428.659 814.437 428.346 814.123 427.959 814.123C427.572 814.123 427.259 814.437 427.259 814.823L427.959 814.823L428.659 814.823ZM427.259 818.906C427.259 819.292 427.572 819.606 427.959 819.606C428.346 819.606 428.659 819.292 428.659 818.906L427.959 818.906L427.259 818.906ZM428.659 822.988C428.659 822.601 428.346 822.288 427.959 822.288C427.572 822.288 427.259 822.601 427.259 822.988L427.959 822.988L428.659 822.988ZM427.259 827.07C427.259 827.456 427.572 827.77 427.959 827.77C428.346 827.77 428.659 827.456 428.659 827.07L427.959 827.07L427.259 827.07ZM428.659 831.152C428.659 830.765 428.346 830.452 427.959 830.452C427.572 830.452 427.259 830.765 427.259 831.152L427.959 831.152L428.659 831.152ZM427.259 835.234C427.259 835.621 427.572 835.934 427.959 835.934C428.346 835.934 428.659 835.621 428.659 835.234L427.959 835.234L427.259 835.234ZM428.659 839.316C428.659 838.93 428.346 838.616 427.959 838.616C427.572 838.616 427.259 838.93 427.259 839.316L427.959 839.316L428.659 839.316ZM427.259 843.398C427.259 843.785 427.572 844.098 427.959 844.098C428.346 844.098 428.659 843.785 428.659 843.398L427.959 843.398L427.259 843.398ZM428.659 847.481C428.659 847.094 428.346 846.781 427.959 846.781C427.572 846.781 427.259 847.094 427.259 847.481L427.959 847.481L428.659 847.481ZM427.259 851.563C427.259 851.949 427.572 852.263 427.959 852.263C428.346 852.263 428.659 851.949 428.659 851.563L427.959 851.563L427.259 851.563ZM428.659 855.645C428.659 855.258 428.346 854.945 427.959 854.945C427.572 854.945 427.259 855.258 427.259 855.645L427.959 855.645L428.659 855.645ZM427.259 859.727C427.259 860.114 427.572 860.427 427.959 860.427C428.346 860.427 428.659 860.114 428.659 859.727L427.959 859.727L427.259 859.727ZM428.659 863.809C428.659 863.423 428.346 863.109 427.959 863.109C427.572 863.109 427.259 863.423 427.259 863.809L427.959 863.809L428.659 863.809ZM427.259 867.891C427.259 868.278 427.572 868.591 427.959 868.591C428.346 868.591 428.659 868.278 428.659 867.891L427.959 867.891L427.259 867.891ZM428.659 871.973C428.659 871.587 428.346 871.273 427.959 871.273C427.572 871.273 427.259 871.587 427.259 871.973L427.959 871.973L428.659 871.973ZM427.259 876.056C427.259 876.442 427.572 876.756 427.959 876.756C428.346 876.756 428.659 876.442 428.659 876.056L427.959 876.056L427.259 876.056ZM428.659 880.138C428.659 879.751 428.346 879.438 427.959 879.438C427.572 879.438 427.259 879.751 427.259 880.138L427.959 880.138L428.659 880.138ZM427.259 884.22C427.259 884.606 427.572 884.92 427.959 884.92C428.346 884.92 428.659 884.606 428.659 884.22L427.959 884.22L427.259 884.22ZM428.659 888.302C428.659 887.915 428.346 887.602 427.959 887.602C427.572 887.602 427.259 887.915 427.259 888.302L427.959 888.302L428.659 888.302ZM427.259 892.384C427.259 892.771 427.572 893.084 427.959 893.084C428.346 893.084 428.659 892.771 428.659 892.384L427.959 892.384L427.259 892.384ZM428.659 896.466C428.659 896.08 428.346 895.766 427.959 895.766C427.572 895.766 427.259 896.08 427.259 896.466L427.959 896.466L428.659 896.466ZM427.259 900.548C427.259 900.935 427.572 901.248 427.959 901.248C428.346 901.248 428.659 900.935 428.659 900.548L427.959 900.548L427.259 900.548ZM428.659 904.631C428.659 904.244 428.346 903.931 427.959 903.931C427.572 903.931 427.259 904.244 427.259 904.631L427.959 904.631L428.659 904.631ZM427.259 908.713C427.259 909.099 427.572 909.413 427.959 909.413C428.346 909.413 428.659 909.099 428.659 908.713L427.959 908.713L427.259 908.713ZM428.659 912.795C428.659 912.408 428.346 912.095 427.959 912.095C427.572 912.095 427.259 912.408 427.259 912.795L427.959 912.795L428.659 912.795ZM427.259 916.877C427.259 917.264 427.572 917.577 427.959 917.577C428.346 917.577 428.659 917.264 428.659 916.877L427.959 916.877L427.259 916.877ZM428.659 920.959C428.659 920.573 428.346 920.259 427.959 920.259C427.572 920.259 427.259 920.573 427.259 920.959L427.959 920.959L428.659 920.959ZM427.959 808.7L427.259 808.7L427.259 810.741L427.959 810.741L428.659 810.741L428.659 808.7L427.959 808.7ZM427.959 814.823L427.259 814.823L427.259 818.906L427.959 818.906L428.659 818.906L428.659 814.823L427.959 814.823ZM427.959 822.988L427.259 822.988L427.259 827.07L427.959 827.07L428.659 827.07L428.659 822.988L427.959 822.988ZM427.959 831.152L427.259 831.152L427.259 835.234L427.959 835.234L428.659 835.234L428.659 831.152L427.959 831.152ZM427.959 839.316L427.259 839.316L427.259 843.398L427.959 843.398L428.659 843.398L428.659 839.316L427.959 839.316ZM427.959 847.481L427.259 847.481L427.259 851.563L427.959 851.563L428.659 851.563L428.659 847.481L427.959 847.481ZM427.959 855.645L427.259 855.645L427.259 859.727L427.959 859.727L428.659 859.727L428.659 855.645L427.959 855.645ZM427.959 863.809L427.259 863.809L427.259 867.891L427.959 867.891L428.659 867.891L428.659 863.809L427.959 863.809ZM427.959 871.973L427.259 871.973L427.259 876.056L427.959 876.056L428.659 876.056L428.659 871.973L427.959 871.973ZM427.959 880.138L427.259 880.138L427.259 884.22L427.959 884.22L428.659 884.22L428.659 880.138L427.959 880.138ZM427.959 888.302L427.259 888.302L427.259 892.384L427.959 892.384L428.659 892.384L428.659 888.302L427.959 888.302ZM427.959 896.466L427.259 896.466L427.259 900.548L427.959 900.548L428.659 900.548L428.659 896.466L427.959 896.466ZM427.959 904.631L427.259 904.631L427.259 908.713L427.959 908.713L428.659 908.713L428.659 904.631L427.959 904.631ZM427.959 912.795L427.259 912.795L427.259 916.877L427.959 916.877L428.659 916.877L428.659 912.795L427.959 912.795Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="report-label_10">
            <g id="Report titles_34">
              <rect width={72} height={20} transform="translate(174 612)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_34"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={174.006} y={626.08}>
                  Alkyl Glycerol
                </tspan>
              </text>
            </g>
            <g id="lines_16">
              <path
                id="Vector_19"
                d="M210.659 636.7L210.659 636L209.259 636L209.259 636.7L209.959 636.7L210.659 636.7ZM209.959 779L214 772L205.918 772L209.959 779ZM209.959 636.7L209.259 636.7L209.259 772.7L209.959 772.7L210.659 772.7L210.659 636.7L209.959 636.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_11">
            <g id="Report titles_35">
              <rect width={64} height={20} transform="translate(274 612)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_35"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={274.395} y={626.08}>
                  Tryptophan
                </tspan>
              </text>
            </g>
            <g id="lines_17">
              <path
                id="Vector_20"
                d="M306.659 636.7L306.659 636L305.259 636L305.259 636.7L305.959 636.7L306.659 636.7ZM305.959 779L310 772L301.918 772L305.959 779ZM305.959 636.7L305.259 636.7L305.259 772.7L305.959 772.7L306.659 772.7L306.659 636.7L305.959 636.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_12">
            <g id="Report titles_36">
              <rect width={44} height={20} transform="translate(411 612)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_36"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={411.057} y={626.08}>
                  Tyrosine
                </tspan>
              </text>
            </g>
            <g id="lines_18">
              <path
                id="Vector_21"
                d="M433.659 636.7L433.659 636L432.259 636L432.259 636.7L432.959 636.7L433.659 636.7ZM432.959 779L437 772L428.918 772L432.959 779ZM432.959 636.7L432.259 636.7L432.259 772.7L432.959 772.7L433.659 772.7L433.659 636.7L432.959 636.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Report titles_37">
            <rect width={39} height={20} transform="translate(612 490)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_37"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={620.279} y={504.086}>
                BH4
              </tspan>
            </text>
          </g>
          <g id="Cofactor_3">
            <rect width={42} height={42} transform="translate(693 453)" fill="white" />
            <g id="diamond_3">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={697.486} y={477.405}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_22">
                <mask id="path-123-inside-3_18291_211496" fill="white">
                  <path d="M714 453L735 463.182V484.818L714 495L693 484.818V463.182L714 453Z" />
                </mask>
                <path
                  d="M714 453L735 463.182V484.818L714 495L693 484.818V463.182L714 453Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-123-inside-3_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_4">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={115.649} y={667.405}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_23">
                <mask id="path-125-inside-4_18291_211496" fill="white">
                  <path d="M125 643L146 653.182V674.818L125 685L104 674.818V653.182L125 643Z" />
                </mask>
                <path
                  d="M125 643L146 653.182V674.818L125 685L104 674.818V653.182L125 643Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-125-inside-4_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_5">
            <g id="diamond_5">
              <text
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={321.649} y={664.405}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_24">
                <mask id="path-127-inside-5_18291_211496" fill="white">
                  <path d="M331 640L352 650.182V671.818L331 682L310 671.818V650.182L331 640Z" />
                </mask>
                <path
                  d="M331 640L352 650.182V671.818L331 682L310 671.818V650.182L331 640Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-127-inside-5_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_6">
            <g id="diamond_6">
              <text
                id="label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={245.649} y={583.405}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_25">
                <mask id="path-129-inside-6_18291_211496" fill="white">
                  <path d="M255 559L276 569.182V590.818L255 601L234 590.818V569.182L255 559Z" />
                </mask>
                <path
                  d="M255 559L276 569.182V590.818L255 601L234 590.818V569.182L255 559Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-129-inside-6_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_7">
            <g id="diamond_7">
              <text
                id="label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={449.649} y={664.405}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_26">
                <mask id="path-131-inside-7_18291_211496" fill="white">
                  <path d="M459 640L480 650.182V671.818L459 682L438 671.818V650.182L459 640Z" />
                </mask>
                <path
                  d="M459 640L480 650.182V671.818L459 682L438 671.818V650.182L459 640Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-131-inside-7_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_8">
            <g id="diamond_8">
              <text
                id="label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={667.812} y={824.405}>
                  Mg
                </tspan>
              </text>
              <g id="Vector_27">
                <mask id="path-133-inside-8_18291_211496" fill="white">
                  <path d="M675 800L696 810.182V831.818L675 842L654 831.818V810.182L675 800Z" />
                </mask>
                <path
                  d="M675 800L696 810.182V831.818L675 842L654 831.818V810.182L675 800Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-133-inside-8_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles_38">
            <rect width={41} height={20} transform="translate(522 950)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_38"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={522.109} y={964.08}>
                2-OHE1
              </tspan>
            </text>
          </g>
          <g id="Report titles_39">
            <rect width={42} height={20} transform="translate(682 950)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_39"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={682.281} y={964.08}>
                4-OHE1
              </tspan>
            </text>
          </g>
          <g id="Report titles_40">
            <rect width={154} height={20} transform="translate(554 1038)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_40"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={554.459} y={1052.08}>
                Methoxyestrogens (inactive)
              </tspan>
            </text>
          </g>
          <g id="lines_19">
            <path
              id="Vector_28"
              d="M589.3 678.742L590 678.742L590 677.342L589.3 677.342L589.3 678.042L589.3 678.742ZM564 678.042L571 682.083L571 674L564 678.042ZM589.3 678.042L589.3 677.342L570.3 677.342L570.3 678.042L570.3 678.742L589.3 678.742L589.3 678.042Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_20">
            <path
              id="Vector_29"
              d="M646.741 723.7L646.741 723L645.341 723L645.341 723.7L646.041 723.7L646.741 723.7ZM646.041 751L650.082 744L642 744L646.041 751ZM646.041 723.7L645.341 723.7L645.341 744.7L646.041 744.7L646.741 744.7L646.741 723.7L646.041 723.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles_41">
            <rect width={45} height={36} transform="translate(514 658)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_41"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={514.01} y={671.405}>
                DNA/RNA{" "}
              </tspan>
              <tspan x={515.777} y={687.405}>
                synthesis
              </tspan>
            </text>
          </g>
          <g id="Report titles_42">
            <rect width={92} height={20} transform="translate(600 751)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_42"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0px"
            >
              <tspan x={600.424} y={764.405}>
                Pyrimidine synthesis
              </tspan>
            </text>
          </g>
          <g id="Report titles_43">
            <rect width={28} height={28} transform="translate(731 517)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_43"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={731.125} y={536.44}>
                THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_44">
            <rect width={58} height={20} transform="translate(716 674)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_44"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={716.295} y={688.08}>
                5,10-MTHF
              </tspan>
            </text>
          </g>
          <g id="Report titles_45">
            <rect width={44} height={20} transform="translate(881 655)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_45"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={881.438} y={669.08}>
                5-MTHF
              </tspan>
            </text>
          </g>
          <g id="lines_21">
            <path
              id="Vector_30"
              d="M1069.86 892.804L1077.66 890.712L1071.95 884.997L1069.86 892.804ZM1115.8 847.848L1116.3 847.353L1115.31 846.363L1114.81 846.858L1115.31 847.353L1115.8 847.848ZM1074.31 888.349L1074.81 888.844L1115.8 847.848L1115.31 847.353L1114.81 846.858L1073.82 887.854L1074.31 888.349Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_22">
            <path
              id="Vector_31"
              d="M1232 894L1229.91 886.193L1224.19 891.908L1232 894ZM1187.85 848.857L1187.35 848.362L1186.36 849.352L1186.86 849.847L1187.35 849.352L1187.85 848.857ZM1227.55 889.545L1228.04 889.05L1187.85 848.857L1187.35 849.352L1186.86 849.847L1227.05 890.04L1227.55 889.545Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Cofactor_9">
            <g id="diamond_9">
              <text
                id="label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1046.17} y={763.405}>
                  B6
                </tspan>
              </text>
              <g id="Vector_32">
                <mask id="path-147-inside-9_18291_211496" fill="white">
                  <path d="M1052 739L1073 749.182V770.818L1052 781L1031 770.818V749.182L1052 739Z" />
                </mask>
                <path
                  d="M1052 739L1073 749.182V770.818L1052 781L1031 770.818V749.182L1052 739Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-147-inside-9_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="report-label_13">
            <g id="lines_23">
              <path
                id="Vector_33"
                d="M1157.66 681.7L1157.66 681L1156.26 681L1156.26 681.7L1156.96 681.7L1157.66 681.7ZM1156.96 732L1161 725L1152.92 725L1156.96 732ZM1156.96 681.7L1156.26 681.7L1156.26 725.7L1156.96 725.7L1157.66 725.7L1157.66 681.7L1156.96 681.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_14">
            <g id="Report titles_46">
              <rect width={78} height={20} transform="translate(1115 736)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_46"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1115.42} y={750.098}>
                  Cystathionine
                </tspan>
              </text>
            </g>
            <g id="lines_24">
              <path
                id="Vector_34"
                d="M1154.66 760.7L1154.66 760L1153.26 760L1153.26 760.7L1153.96 760.7L1154.66 760.7ZM1153.96 821L1158 814L1149.92 814L1153.96 821ZM1153.96 760.7L1153.26 760.7L1153.26 814.7L1153.96 814.7L1154.66 814.7L1154.66 760.7L1153.96 760.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_15">
            <g id="Report titles_47">
              <rect width={99} height={20} transform="translate(995 901)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_47"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={995.457} y={915.08}>
                  Cysteine Sulfinate
                </tspan>
              </text>
            </g>
            <g id="lines_25">
              <path
                id="Vector_35"
                d="M1045.16 925.7L1045.16 925L1043.76 925L1043.76 925.7L1044.46 925.7L1045.16 925.7ZM1044.46 958L1048.5 951L1040.42 951L1044.46 958ZM1044.46 925.7L1043.76 925.7L1043.76 951.7L1044.46 951.7L1045.16 951.7L1045.16 925.7L1044.46 925.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_16">
            <g id="Report titles_48">
              <rect width={85} height={20} transform="translate(1002 961)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_48"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1002.07} y={975.08}>
                  Pyruvate Sulfite
                </tspan>
              </text>
            </g>
            <g id="lines_26">
              <path
                id="Vector_36"
                d="M1045.16 985.7L1045.16 985L1043.76 985L1043.76 985.7L1044.46 985.7L1045.16 985.7ZM1044.46 1023L1048.5 1016L1040.42 1016L1044.46 1023ZM1044.46 985.7L1043.76 985.7L1043.76 1016.7L1044.46 1016.7L1045.16 1016.7L1045.16 985.7L1044.46 985.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Report titles_49">
            <rect width={39} height={20} transform="translate(1025 1029)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_49"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1025.33} y={1043.08}>
                Sulfate
              </tspan>
            </text>
          </g>
          <g id="report-label_17">
            <g id="Report titles_50">
              <rect width={40} height={20} transform="translate(1228 901)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_50"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1228.17} y={915.08}>
                  Taurine
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_18">
            <g id="Report titles_51">
              <rect width={49} height={20} transform="translate(1128 834)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_51"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1128.42} y={848.098}>
                  Cysteine
                </tspan>
              </text>
            </g>
            <g id="lines_27">
              <path
                id="Vector_37"
                d="M1153.16 858.7L1153.16 858L1151.76 858L1151.76 858.7L1152.46 858.7L1153.16 858.7ZM1152.46 896L1156.5 889L1148.42 889L1152.46 896ZM1152.46 858.7L1151.76 858.7L1151.76 889.7L1152.46 889.7L1153.16 889.7L1153.16 858.7L1152.46 858.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Report titles_52">
            <rect width={66} height={20} transform="translate(1124 900)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_52"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={1124.48} y={914.08}>
                Glutathione
              </tspan>
            </text>
          </g>
          <g id="lines_28">
            <path
              id="Vector_38"
              d="M744.797 417.205L744.792 416.505L743.392 416.515L743.397 417.215L744.097 417.21L744.797 417.205ZM744.82 519.963L748.812 512.934L740.73 512.991L744.82 519.963ZM744.097 417.21L743.397 417.215L744.076 513.668L744.776 513.663L745.476 513.658L744.797 417.205L744.097 417.21Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_29">
            <mask id="path-161-inside-10_18291_211496" fill="white">
              <path d="M614 648L614 710L590 710L590 648L614 648Z" />
            </mask>
            <path
              d="M590 710L589.3 710L589.3 710.7L590 710.7L590 710ZM590 648L590 647.3L589.3 647.3L589.3 648L590 648ZM614 648L614 647.3L612 647.3L612 648L612 648.7L614 648.7L614 648ZM608 648L608 647.3L604 647.3L604 648L604 648.7L608 648.7L608 648ZM600 648L600 647.3L596 647.3L596 648L596 648.7L600 648.7L600 648ZM592 648L592 647.3L590 647.3L590 648L590 648.7L592 648.7L592 648ZM590 648L589.3 648L589.3 649.937L590 649.937L590.7 649.937L590.7 648L590 648ZM590 653.812L589.3 653.812L589.3 657.687L590 657.687L590.7 657.687L590.7 653.812L590 653.812ZM590 661.562L589.3 661.562L589.3 665.437L590 665.437L590.7 665.437L590.7 661.562L590 661.562ZM590 669.312L589.3 669.312L589.3 673.187L590 673.187L590.7 673.187L590.7 669.312L590 669.312ZM590 677.062L589.3 677.062L589.3 680.937L590 680.937L590.7 680.937L590.7 677.062L590 677.062ZM590 684.812L589.3 684.812L589.3 688.687L590 688.687L590.7 688.687L590.7 684.812L590 684.812ZM590 692.562L589.3 692.562L589.3 696.437L590 696.437L590.7 696.437L590.7 692.562L590 692.562ZM590 700.312L589.3 700.312L589.3 704.187L590 704.187L590.7 704.187L590.7 700.312L590 700.312ZM590 708.062L589.3 708.062L589.3 710L590 710L590.7 710L590.7 708.062L590 708.062ZM590 710L590 710.7L592 710.7L592 710L592 709.3L590 709.3L590 710ZM596 710L596 710.7L600 710.7L600 710L600 709.3L596 709.3L596 710ZM604 710L604 710.7L608 710.7L608 710L608 709.3L604 709.3L604 710ZM612 710L612 710.7L614 710.7L614 710L614 709.3L612 709.3L612 710ZM590 710L588.6 710L588.6 711.4L590 711.4L590 710ZM590 648L590 646.6L588.6 646.6L588.6 648L590 648ZM614 648L614 646.6L612 646.6L612 648L612 649.4L614 649.4L614 648ZM608 648L608 646.6L604 646.6L604 648L604 649.4L608 649.4L608 648ZM600 648L600 646.6L596 646.6L596 648L596 649.4L600 649.4L600 648ZM592 648L592 646.6L590 646.6L590 648L590 649.4L592 649.4L592 648ZM590 648L588.6 648L588.6 649.937L590 649.937L591.4 649.937L591.4 648L590 648ZM590 653.812L588.6 653.812L588.6 657.687L590 657.687L591.4 657.687L591.4 653.812L590 653.812ZM590 661.562L588.6 661.562L588.6 665.437L590 665.437L591.4 665.437L591.4 661.562L590 661.562ZM590 669.312L588.6 669.312L588.6 673.187L590 673.187L591.4 673.187L591.4 669.312L590 669.312ZM590 677.062L588.6 677.062L588.6 680.937L590 680.937L591.4 680.937L591.4 677.062L590 677.062ZM590 684.812L588.6 684.812L588.6 688.687L590 688.687L591.4 688.687L591.4 684.812L590 684.812ZM590 692.562L588.6 692.562L588.6 696.437L590 696.437L591.4 696.437L591.4 692.562L590 692.562ZM590 700.312L588.6 700.312L588.6 704.187L590 704.187L591.4 704.187L591.4 700.312L590 700.312ZM590 708.062L588.6 708.062L588.6 710L590 710L591.4 710L591.4 708.062L590 708.062ZM590 710L590 711.4L592 711.4L592 710L592 708.6L590 708.6L590 710ZM596 710L596 711.4L600 711.4L600 710L600 708.6L596 708.6L596 710ZM604 710L604 711.4L608 711.4L608 710L608 708.6L604 708.6L604 710ZM612 710L612 711.4L614 711.4L614 710L614 708.6L612 708.6L612 710Z"
              fill="#1A1A1A"
              mask="url(#path-161-inside-10_18291_211496)"
            />
          </g>
          <g id="Frame 470">
            <rect x={606.3} y={693.3} width={75.4} height={29.4} rx={4.7} fill="white" />
            <rect
              x={606.3}
              y={693.3}
              width={75.4}
              height={29.4}
              rx={4.7}
              stroke="#282828"
              strokeWidth={1.4}
            />
            <g id="Report titles_53">
              <rect width={42} height={28} transform="translate(623 694)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_53"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={623.43} y={713.464}>
                  dTMP
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_54">
            <rect width={43} height={28} transform="translate(623 630)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_54"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={623.023} y={649.464}>
                dUMP
              </tspan>
            </text>
          </g>
          <g id="Cofactor_10">
            <g id="diamond_10">
              <text
                id="label_8"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={839.248} y={763.405}>
                  B3
                </tspan>
              </text>
              <g id="Vector_39">
                <mask id="path-167-inside-11_18291_211496" fill="white">
                  <path d="M845 739L866 749.182V770.818L845 781L824 770.818V749.182L845 739Z" />
                </mask>
                <path
                  d="M845 739L866 749.182V770.818L845 781L824 770.818V749.182L845 739Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-167-inside-11_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_11">
            <g id="diamond_11">
              <text
                id="label_9"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={768.248} y={571.405}>
                  B3
                </tspan>
              </text>
              <g id="Vector_40">
                <mask id="path-169-inside-12_18291_211496" fill="white">
                  <path d="M774 547L795 557.182V578.818L774 589L753 578.818V557.182L774 547Z" />
                </mask>
                <path
                  d="M774 547L795 557.182V578.818L774 589L753 578.818V557.182L774 547Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-169-inside-12_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_12">
            <g id="diamond_12">
              <text
                id="label_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={768.248} y={612.405}>
                  B3
                </tspan>
              </text>
              <g id="Vector_41">
                <mask id="path-171-inside-13_18291_211496" fill="white">
                  <path d="M774 588L795 598.182V619.818L774 630L753 619.818V598.182L774 588Z" />
                </mask>
                <path
                  d="M774 588L795 598.182V619.818L774 630L753 619.818V598.182L774 588Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-171-inside-13_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_13">
            <g id="diamond_13">
              <text
                id="label_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={813.17} y={612.405}>
                  B6
                </tspan>
              </text>
              <g id="Vector_42">
                <mask id="path-173-inside-14_18291_211496" fill="white">
                  <path d="M819 588L840 598.182V619.818L819 630L798 619.818V598.182L819 588Z" />
                </mask>
                <path
                  d="M819 588L840 598.182V619.818L819 630L798 619.818V598.182L819 588Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-173-inside-14_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_14">
            <g id="diamond_14">
              <text
                id="label_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={813.776} y={682.405}>
                  FAD
                </tspan>
              </text>
              <g id="Vector_43">
                <mask id="path-175-inside-15_18291_211496" fill="white">
                  <path d="M823 658L844 668.182V689.818L823 700L802 689.818V668.182L823 658Z" />
                </mask>
                <path
                  d="M823 658L844 668.182V689.818L823 700L802 689.818V668.182L823 658Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-175-inside-15_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_15">
            <g id="diamond_15">
              <text
                id="label_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={792.429} y={763.405}>
                  B2
                </tspan>
              </text>
              <g id="Vector_44">
                <mask id="path-177-inside-16_18291_211496" fill="white">
                  <path d="M798 739L819 749.182V770.818L798 781L777 770.818V749.182L798 739Z" />
                </mask>
                <path
                  d="M798 739L819 749.182V770.818L798 781L777 770.818V749.182L798 739Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-177-inside-16_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_16">
            <g id="diamond_16">
              <text
                id="label_14"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1298.25} y={687.405}>
                  B3
                </tspan>
              </text>
              <g id="Vector_45">
                <mask id="path-179-inside-17_18291_211496" fill="white">
                  <path d="M1304 663L1325 673.182V694.818L1304 705L1283 694.818V673.182L1304 663Z" />
                </mask>
                <path
                  d="M1304 663L1325 673.182V694.818L1304 705L1283 694.818V673.182L1304 663Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-179-inside-17_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_17">
            <g id="diamond_17">
              <text
                id="label_15"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1095.01} y={580.405}>
                  SAMe
                </tspan>
              </text>
              <g id="Vector_46">
                <mask id="path-181-inside-18_18291_211496" fill="white">
                  <path d="M1108 556L1129 566.182V587.818L1108 598L1087 587.818V566.182L1108 556Z" />
                </mask>
                <path
                  d="M1108 556L1129 566.182V587.818L1108 598L1087 587.818V566.182L1108 556Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-181-inside-18_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_18">
            <g id="diamond_18">
              <text
                id="label_16"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1105.55} y={507.405}>
                  Zn
                </tspan>
              </text>
              <g id="Vector_47">
                <mask id="path-183-inside-19_18291_211496" fill="white">
                  <path d="M1111 483L1132 493.182V514.818L1111 525L1090 514.818V493.182L1111 483Z" />
                </mask>
                <path
                  d="M1111 483L1132 493.182V514.818L1111 525L1090 514.818V493.182L1111 483Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-183-inside-19_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Vitamin-Mineral_2">
            <g id="diamond_19">
              <text
                id="label_17"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={966.753} y={514.767}>
                  B12
                </tspan>
              </text>
              <path
                id="Vector_48"
                d="M976.378 485.938L1000.38 509.938L976.378 533.938L952.378 509.938L976.378 485.938Z"
                stroke="#1A1A1A"
              />
            </g>
          </g>
          <g id="Vitamin-Mineral_3">
            <g id="diamond_20">
              <text
                id="label_18"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={968.681} y={647.405}>
                  B12
                </tspan>
              </text>
              <path
                id="Vector_49"
                d="M975.378 623.938L995.378 643.938L975.378 663.938L955.378 643.938L975.378 623.938Z"
                stroke="#1A1A1A"
                strokeWidth={1.11579}
              />
            </g>
            <text
              id="Title"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={10}
              letterSpacing="0em"
            >
              <tspan x={954.904} y={677.405}>
                Reduced
              </tspan>
            </text>
          </g>
          <g id="Cofactor_19">
            <g id="diamond_21">
              <text
                id="label_19"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1363.54} y={544.405}>
                  Choline
                </tspan>
              </text>
              <g id="Vector_50">
                <mask id="path-190-inside-20_18291_211496" fill="white">
                  <path d="M1381 520L1402 530.182V551.818L1381 562L1360 551.818V530.182L1381 520Z" />
                </mask>
                <path
                  d="M1381 520L1402 530.182V551.818L1381 562L1360 551.818V530.182L1381 520Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-190-inside-20_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_20">
            <g id="diamond_22">
              <text
                id="label_20"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={1047.17} y={680.405}>
                  B6
                </tspan>
              </text>
              <g id="Vector_51">
                <mask id="path-192-inside-21_18291_211496" fill="white">
                  <path d="M1053 656L1074 666.182V687.818L1053 698L1032 687.818V666.182L1053 656Z" />
                </mask>
                <path
                  d="M1053 656L1074 666.182V687.818L1053 698L1032 687.818V666.182L1053 656Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-192-inside-21_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_21">
            <g id="diamond_23">
              <text
                id="label_21"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={928.969} y={977.405}>
                  Mo
                </tspan>
              </text>
              <g id="Vector_52">
                <mask id="path-194-inside-22_18291_211496" fill="white">
                  <path d="M936 953L957 963.182V984.818L936 995L915 984.818V963.182L936 953Z" />
                </mask>
                <path
                  d="M936 953L957 963.182V984.818L936 995L915 984.818V963.182L936 953Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-194-inside-22_18291_211496)"
                />
              </g>
            </g>
          </g>
          <g id="gene-CBS" {...geneGroupProps("CBS", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M1071 692.7H1143C1144.82 692.7 1146.3 694.177 1146.3 696V712C1146.3 713.823 1144.82 715.3 1143 715.3H1071C1069.18 715.3 1067.7 713.823 1067.7 712V696C1067.7 694.177 1069.18 692.7 1071 692.7Z"
                fill={cbs.lozengeFill}
              />
              <text
                id="gene-label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1093.57} y={708.767}>
                  CBS
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cbs"
              groupId="gene-snps_2"
              genePalette={cbs}
              startX={1075}
              startY={718}
              snpCount={getGeneSnpCount("CBS", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CTH" {...geneGroupProps("CTH", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M1071 775.7H1143C1144.82 775.7 1146.3 777.177 1146.3 779V795C1146.3 796.823 1144.82 798.3 1143 798.3H1071C1069.18 798.3 1067.7 796.823 1067.7 795V779C1067.7 777.177 1069.18 775.7 1071 775.7Z"
                fill={cth.lozengeFill}
              />
              <text
                id="gene-label_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1093.4} y={791.767}>
                  CTH
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cth"
              groupId="gene-snps_3"
              genePalette={cth}
              startX={1075}
              startY={801}
              snpCount={getGeneSnpCount("CTH", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SUOX" {...geneGroupProps("SUOX", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M955 990.7H1027C1028.82 990.7 1030.3 992.177 1030.3 994V1010C1030.3 1011.82 1028.82 1013.3 1027 1013.3H955C953.177 1013.3 951.7 1011.82 951.7 1010V994C951.7 992.177 953.177 990.7 955 990.7Z"
                fill={suox.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={972.851} y={1006.77}>
                  SUOX
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="suox"
              groupId="gene-snps_4"
              genePalette={suox}
              startX={959}
              startY={1016}
              snpCount={getGeneSnpCount("SUOX", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TPH" {...geneGroupProps("TPH", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M271 685.7H343C344.823 685.7 346.3 687.177 346.3 689V705C346.3 706.823 344.823 708.3 343 708.3H271C269.177 708.3 267.7 706.823 267.7 705V689C267.7 687.177 269.177 685.7 271 685.7Z"
                fill={tph.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={294.367} y={701.767}>
                  TPH
                </tspan>
              </text>
              <path
                id="*_2"
                d="M356.875 682.754V684.477L354.199 684.384L355.728 686.692L354.228 687.615L352.875 685.123L351.522 687.615L350.022 686.692L351.551 684.384L348.875 684.477L348.875 682.754L351.551 682.846L350.022 680.538L351.522 679.615L352.875 682.108L354.228 679.615L355.728 680.538L354.199 682.846L356.875 682.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="tph"
              groupId="gene-snps_5"
              genePalette={tph}
              startX={275}
              startY={711}
              snpCount={getGeneSnpCount("TPH", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTRR" {...geneGroupProps("MTRR", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M1008 564.7H1080C1081.82 564.7 1083.3 566.177 1083.3 568V584C1083.3 585.823 1081.82 587.3 1080 587.3H1008C1006.18 587.3 1004.7 585.823 1004.7 584V568C1004.7 566.177 1006.18 564.7 1008 564.7Z"
                fill={mtrr.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1026.03} y={580.767}>
                  MTRR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mtrr"
              groupId="gene-snps_6"
              genePalette={mtrr}
              startX={1012}
              startY={590}
              snpCount={getGeneSnpCount("MTRR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AHCY" {...geneGroupProps("AHCY", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M1217 645.7H1289C1290.82 645.7 1292.3 647.177 1292.3 649V665C1292.3 666.823 1290.82 668.3 1289 668.3H1217C1215.18 668.3 1213.7 666.823 1213.7 665V649C1213.7 647.177 1215.18 645.7 1217 645.7Z"
                fill={ahcy.lozengeFill}
              />
              <text
                id="gene-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1234.5} y={661.767}>
                  AHCY
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="ahcy"
              groupId="gene-snps_7"
              genePalette={ahcy}
              startX={1221}
              startY={671}
              snpCount={getGeneSnpCount("AHCY", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-BHMT" {...geneGroupProps("BHMT", onGeneClick)}>
            <g id="gene-lozenge_13">
              <path
                d="M1121 523.7H1193C1194.82 523.7 1196.3 525.177 1196.3 527V543C1196.3 544.823 1194.82 546.3 1193 546.3H1121C1119.18 546.3 1117.7 544.823 1117.7 543V527C1117.7 525.177 1119.18 523.7 1121 523.7Z"
                fill={bhmt.lozengeFill}
              />
              <text
                id="gene-label_9"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1138.56} y={539.767}>
                  BHMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="bhmt"
              groupId="gene-snps_8"
              genePalette={bhmt}
              startX={1125}
              startY={549}
              snpCount={getGeneSnpCount("BHMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-DHFR" {...geneGroupProps("DHFR", onGeneClick)}>
            <g id="gene-lozenge_14">
              <path
                d="M661 417.7H733C734.823 417.7 736.3 419.177 736.3 421V437C736.3 438.823 734.823 440.3 733 440.3H661C659.177 440.3 657.7 438.823 657.7 437V421C657.7 419.177 659.177 417.7 661 417.7Z"
                fill={dhfr.lozengeFill}
              />
              <text
                id="gene-label_10"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={679.363} y={433.767}>
                  DHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="dhfr"
              groupId="gene-snps_9"
              genePalette={dhfr}
              startX={665}
              startY={443}
              snpCount={getGeneSnpCount("DHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TH" {...geneGroupProps("TH", onGeneClick)}>
            <g id="gene-lozenge_15">
              <path
                d="M398 685.7H470C471.823 685.7 473.3 687.177 473.3 689V705C473.3 706.823 471.823 708.3 470 708.3H398C396.177 708.3 394.7 706.823 394.7 705V689C394.7 687.177 396.177 685.7 398 685.7Z"
                fill={th.lozengeFill}
              />
              <text
                id="gene-label_11"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={425.496} y={701.767}>
                  TH
                </tspan>
              </text>
              <path
                id="*_3"
                d="M483.875 682.754V684.477L481.199 684.384L482.728 686.692L481.228 687.615L479.875 685.123L478.522 687.615L477.022 686.692L478.551 684.384L475.875 684.477L475.875 682.754L478.551 682.846L477.022 680.538L478.522 679.615L479.875 682.108L481.228 679.615L482.728 680.538L481.199 682.846L483.875 682.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="th"
              groupId="gene-snps_10"
              genePalette={th}
              startX={402}
              startY={711}
              snpCount={getGeneSnpCount("TH", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-COMT" {...geneGroupProps("COMT", onGeneClick)}>
            <g id="gene-lozenge_16">
              <path
                d="M584 837.7H656C657.823 837.7 659.3 839.177 659.3 841V857C659.3 858.823 657.823 860.3 656 860.3H584C582.177 860.3 580.7 858.823 580.7 857V841C580.7 839.177 582.177 837.7 584 837.7Z"
                fill={comt.lozengeFill}
              />
              <text
                id="gene-label_12"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={599.848} y={853.767}>
                  COMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="comt"
              groupId="gene-snps_11"
              genePalette={comt}
              startX={588}
              startY={863}
              snpCount={getGeneSnpCount("COMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_17">
              <path
                d="M64 687.7H136C137.823 687.7 139.3 689.177 139.3 691V707C139.3 708.823 137.823 710.3 136 710.3H64C62.1775 710.3 60.7002 708.823 60.7002 707V691C60.7002 689.177 62.1775 687.7 64 687.7Z"
                fill={nos3.lozengeFill}
              />
              <text
                id="gene-label_13"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={82.042} y={703.767}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3"
              groupId="gene-snps_12"
              genePalette={nos3}
              startX={68}
              startY={713}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3_2" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_18">
              <path
                d="M501 259.7H573C574.823 259.7 576.3 261.177 576.3 263V279C576.3 280.823 574.823 282.3 573 282.3H501C499.177 282.3 497.7 280.823 497.7 279V263C497.7 261.177 499.177 259.7 501 259.7Z"
                fill={nos3.lozengeFill}
              />
              <text
                id="gene-label_14"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={519.042} y={275.767}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3-2"
              groupId="gene-snps_13"
              genePalette={nos3}
              startX={505}
              startY={285}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SOD1/3" {...geneGroupProps("SOD1/3", onGeneClick)}>
            <g id="gene-lozenge_19">
              <path
                d="M245 259.7H319C320.823 259.7 322.3 261.177 322.3 263V279C322.3 280.823 320.823 282.3 319 282.3H245C243.177 282.3 241.7 280.823 241.7 279V263C241.7 261.177 243.177 259.7 245 259.7Z"
                fill={sod1_3.lozengeFill}
              />
              <text
                id="gene-label_15"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={257.493} y={275.767}>
                  SOD1/3
                </tspan>
              </text>
              <path
                id="*_4"
                d="M332.875 256.754V258.477L330.199 258.384L331.728 260.692L330.228 261.615L328.875 259.123L327.522 261.615L326.022 260.692L327.551 258.384L324.875 258.477L324.875 256.754L327.551 256.846L326.022 254.538L327.522 253.615L328.875 256.108L330.228 253.615L331.728 254.538L330.199 256.846L332.875 256.754Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="sod1-3"
              groupId="gene-snps_14"
              genePalette={sod1_3}
              startX={249}
              startY={285}
              snpCount={getGeneSnpCount("SOD1/3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
            <g id="gene-lozenge_20">
              <path
                d="M67 393.7H139C140.823 393.7 142.3 395.177 142.3 397V413C142.3 414.823 140.823 416.3 139 416.3H67C65.1775 416.3 63.7002 414.823 63.7002 413V397C63.7002 395.177 65.1775 393.7 67 393.7Z"
                fill={gpx1.lozengeFill}
              />
              <text
                id="gene-label_16"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={86.9492} y={409.767}>
                  GPX1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gpx1"
              groupId="gene-snps_15"
              genePalette={gpx1}
              startX={71}
              startY={419}
              snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-TCN2" {...geneGroupProps("TCN2", onGeneClick)}>
            <g id="gene-lozenge_21">
              <path
                d="M860 262.7H932C933.823 262.7 935.3 264.177 935.3 266V282C935.3 283.823 933.823 285.3 932 285.3H860C858.177 285.3 856.7 283.823 856.7 282V266C856.7 264.177 858.177 262.7 860 262.7Z"
                fill={tcn2.lozengeFill}
              />
              <text
                id="gene-label_17"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={878.91} y={278.767}>
                  TCN2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="tcn2"
              groupId="gene-snps_16"
              genePalette={tcn2}
              startX={864}
              startY={288}
              snpCount={getGeneSnpCount("TCN2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-FUT2" {...geneGroupProps("FUT2", onGeneClick)}>
            <g id="gene-lozenge_22">
              <path
                d="M1044 262.7H1116C1117.82 262.7 1119.3 264.177 1119.3 266V282C1119.3 283.823 1117.82 285.3 1116 285.3H1044C1042.18 285.3 1040.7 283.823 1040.7 282V266C1040.7 264.177 1042.18 262.7 1044 262.7Z"
                fill={fut2.lozengeFill}
              />
              <text
                id="gene-label_18"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={1064.49} y={278.767}>
                  FUT2
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="fut2"
              groupId="gene-snps_17"
              genePalette={fut2}
              startX={1048}
              startY={288}
              snpCount={getGeneSnpCount("FUT2", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SHMT" {...geneGroupProps("SHMT", onGeneClick)}>
            <g id="gene-lozenge_23">
              <path
                d="M673 554.7H745C746.823 554.7 748.3 556.177 748.3 558V574C748.3 575.823 746.823 577.3 745 577.3H673C671.177 577.3 669.7 575.823 669.7 574V558C669.7 556.177 671.177 554.7 673 554.7Z"
                fill={shmt.lozengeFill}
              />
              <text
                id="gene-label_19"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={690.851} y={570.767}>
                  SHMT
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="shmt"
              groupId="gene-snps_18"
              genePalette={shmt}
              startX={677}
              startY={580}
              snpCount={getGeneSnpCount("SHMT", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTHFD1" {...geneGroupProps("MTHFD1", onGeneClick)}>
            <g id="gene-lozenge_24">
              <path
                d="M672 594.7H747C748.823 594.7 750.3 596.177 750.3 598V614C750.3 615.823 748.823 617.3 747 617.3H672C670.177 617.3 668.7 615.823 668.7 614V598C668.7 596.177 670.177 594.7 672 594.7Z"
                fill={mthfd1.lozengeFill}
              />
              <text
                id="gene-label_20"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={684.303} y={610.767}>
                  MTHFD1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mthfd1"
              groupId="gene-snps_19"
              genePalette={mthfd1}
              startX={676}
              startY={620}
              snpCount={getGeneSnpCount("MTHFD1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTHFR" {...geneGroupProps("MTHFR", onGeneClick)}>
            <g id="gene-lozenge_25">
              <path
                d="M784 703.7H856C857.823 703.7 859.3 705.177 859.3 707V723C859.3 724.823 857.823 726.3 856 726.3H784C782.177 726.3 780.7 724.823 780.7 723V707C780.7 705.177 782.177 703.7 784 703.7Z"
                fill={mthfr.lozengeFill}
              />
              <text
                id="gene-label_21"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={797.975} y={719.767}>
                  MTHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mthfr"
              groupId="gene-snps_20"
              genePalette={mthfr}
              startX={788}
              startY={729}
              snpCount={getGeneSnpCount("MTHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-MTR" {...geneGroupProps("MTR", onGeneClick)}>
            <g id="gene-lozenge_26">
              <path
                d="M885 593.7H957C958.823 593.7 960.3 595.177 960.3 597V613C960.3 614.823 958.823 616.3 957 616.3H885C883.177 616.3 881.7 614.823 881.7 613V597C881.7 595.177 883.177 593.7 885 593.7Z"
                fill={mtr.lozengeFill}
              />
              <text
                id="gene-label_22"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={907.308} y={609.767}>
                  MTR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="mtr"
              groupId="gene-snps_21"
              genePalette={mtr}
              startX={889}
              startY={619}
              snpCount={getGeneSnpCount("MTR", expectedSnps, geneColors)}
            />
          </g>
          <g id="Cofactor_22">
            <g id="diamond_24">
              <text
                id="label_22"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={10}
                letterSpacing="0em"
              >
                <tspan x={860.551} y={635.405}>
                  Zn
                </tspan>
              </text>
              <g id="Vector_53">
                <mask id="path-239-inside-23_18291_211496" fill="white">
                  <path d="M866 611L887 621.182V642.818L866 653L845 642.818V621.182L866 611Z" />
                </mask>
                <path
                  d="M866 611L887 621.182V642.818L866 653L845 642.818V621.182L866 611Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-239-inside-23_18291_211496)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationMethylationDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1424}
    height={869}
    viewBox="0 212 1424 869"
    fill="none"
    {...props}
  >
    <MethylationMethylationDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211496">
        <rect width={1424} height={1081} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211496">
        <rect width={1424} height={869} fill="white" transform="translate(0 212)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationMethylationDiagram;
